<template>
  <div class="sticky-top">
    <cookie-law theme="dark-lime" position="top" buttonText>
      <div slot-scope="props" class="width-100">
        <div>
          <div class="row align-items-center">
            <div class="col-12 col-lg-4">
              <h4>This website uses cookies</h4>
            </div>
            <div class="col-12 col-lg-6">
              <p class="cookie-text">
                By continuing to browse this website you are agreeing to our use
                of cookies. Find out more by reading our
                <router-link to="/cookiesprivacyPolicy" style="color: white">
                  <u>Cookie Policy</u>.
                </router-link>
              </p>
            </div>
            <div class="col-12 col-lg-2">
              <img
                @click="props.accept"
                src="@/assets/img/svg/cancel.svg"
                height="30"
                width="30"
              />
            </div>
          </div>
        </div>
      </div>
    </cookie-law>
    <!-- COUNTRY SELECTION MODAL -->
    <b-modal ref="countryModalRef" id="countryModal" hide-header hide-footer>
      <div class="modal-title">Choose your country</div>
      <div class="p-3">
        <div class="row">
          <div
            class="text-center col"
            v-for="(country, index) in countries"
            :index="index"
            :key="index"
          >
            <!-- <img
              :src="country.CountryFlag"
              class="flag-class"
              height="60px"
              width="100px"
              @click="setCountry(country)"
              style="cursor:pointer"
            /> -->
            <h6 class="pt-3">{{ country.country_name }}</h6>
          </div>
        </div>
      </div>
    </b-modal>
    <aside :style="{ right: rightOpen }" class="d-lg-none w-90">
      <svg
        class="c-pointer"
        width="14"
        height="14"
        viewBox="0 0 14 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        v-on:click="openSideNav()"
      >
        <path
          d="M0.353415 6.15663C-0.120763 6.63629 -0.117059 7.41472 0.360136 7.89374L6.011 13.5663C7.33072 14.8814 9.31047 12.9086 7.99075 11.5935L5.52536 9.13668C5.11419 8.72695 5.2524 8.3948 5.8273 8.3948H12.6001C13.3736 8.3948 14 7.77055 14 6.99983C14 6.22945 13.3736 5.60485 12.6001 5.60485H5.8273C5.24938 5.60485 5.1123 5.27462 5.52536 4.86305L7.99075 2.40652C9.31047 1.09141 7.33072 -0.881435 6.011 0.433678L0.353415 6.15663Z"
          fill="white"
        />
      </svg>
      <!-- SHOW THIS DIV WHEN USER IS LOGGED IN -->
      <div
        v-if="isUserLoggedIn"
        class="d-flex justify-content-between align-items-center"
      >
        <!-- <h6 class="mb-0 font-weight-bold pt-3">Your Dashboard</h6> -->
        <!-- <div class="d-table text-center d-none">
          <form>
            <div class="profile-img"></div>
            <input type="file" id="update-profile" class="d-none" />
            <label class="small" for="update-profile">Edit</label>
          </form>
        </div>-->
      </div>
      <!-- SHOW THIS DIV WHEN USER IS NOT LOGGED IN -->
      <div
        v-if="!isUserLoggedIn"
        class="d-flex justify-content-between align-items-center mb-4 mt-3"
      >
        <h6 class="mb-0 font-weight-bold">Hello Friend !</h6>
        <div>
          <router-link
            @click.native="
              openSideNav();
              showSignUp();
            "
            to="#"
            class="small text-white"
            >Sign Up</router-link
          >
          <span>|</span>
          <router-link
            @click.native="
              openSideNav();
              checkSignIn();
            "
            to="#"
            class="small text-white"
            >Sign In</router-link
          >
        </div>
      </div>
      <ul class="profileMenu-list">
        <li>
          <router-link
            v-on:click.native="
              openSideNav();
              checkSignIn();
            "
            :to="isUserLoggedIn ? '/profile/myaccount' : '#'"
            v-bind:class="[$route.path == 'myaccount' ? 'active' : '']"
          >
            <div>
              <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M0.577834 5.00569C1.7963 1.97785 4.73412 -0.00409475 7.99771 1.35e-05C11.2621 -0.00596662 14.2017 1.9753 15.4213 5.00357C16.641 8.03183 15.8952 11.4976 13.538 13.7561C13.5358 13.7583 13.5342 13.761 13.5327 13.7637C13.5318 13.7654 13.5308 13.767 13.5298 13.7686C13.529 13.7696 13.5281 13.7706 13.5271 13.7715C13.5012 13.7965 13.474 13.8193 13.4469 13.842L13.4469 13.842L13.4469 13.8421C13.4256 13.8599 13.4043 13.8778 13.3838 13.8966C13.2552 14.0154 13.1267 14.1308 12.9913 14.2394C12.9494 14.273 12.9066 14.3044 12.8636 14.3359C12.8321 14.3589 12.8005 14.382 12.7691 14.4062L12.7691 14.4062C12.6411 14.5016 12.5132 14.597 12.3795 14.6849C12.3172 14.7277 12.2536 14.7656 12.1897 14.8036C12.1604 14.821 12.1312 14.8384 12.1019 14.8563L12.0698 14.8757L12.0698 14.8757C11.9572 14.9436 11.8447 15.0113 11.7284 15.0734C11.6481 15.1159 11.5665 15.154 11.4848 15.1921C11.4567 15.2052 11.4286 15.2183 11.4005 15.2316L11.3252 15.2674L11.3251 15.2674C11.2304 15.3125 11.1356 15.3576 11.0395 15.3973C10.9404 15.4383 10.8341 15.4754 10.7351 15.51L10.735 15.51L10.6687 15.5333C10.6351 15.5452 10.6015 15.5573 10.5678 15.5695C10.4852 15.5995 10.4023 15.6295 10.3174 15.6555C10.2102 15.6878 10.1008 15.7143 9.99147 15.7407L9.9073 15.7612C9.85839 15.7722 9.80947 15.7848 9.76055 15.7974L9.76053 15.7974L9.76042 15.7974C9.69514 15.8142 9.62985 15.831 9.56457 15.844C9.42702 15.8715 9.28773 15.8902 9.14821 15.9089L9.08703 15.9172C9.05027 15.9223 9.01383 15.9282 8.97741 15.934L8.9774 15.934L8.97738 15.934C8.9159 15.944 8.85448 15.9539 8.79171 15.96C8.53009 15.9857 8.26618 16 8 16C7.73381 16 7.4699 15.9857 7.20828 15.96C7.14551 15.9539 7.08409 15.944 7.02261 15.934L7.02257 15.934C6.98616 15.9282 6.94972 15.9223 6.91296 15.9172L6.85179 15.9089C6.71227 15.8902 6.57298 15.8715 6.43542 15.844C6.35415 15.8283 6.27615 15.8081 6.19803 15.7879L6.19798 15.7879L6.19787 15.7879L6.19778 15.7879C6.16287 15.7789 6.12794 15.7698 6.09269 15.7612L6.00851 15.7407L6.00849 15.7407L6.00847 15.7407C5.8992 15.7143 5.78979 15.6878 5.68255 15.6555C5.59165 15.6277 5.50771 15.5972 5.41786 15.5646L5.41783 15.5646L5.33125 15.5333C5.2984 15.5215 5.26563 15.5101 5.23292 15.4987L5.23282 15.4986L5.2328 15.4986L5.23278 15.4986C5.14157 15.4668 5.05089 15.4351 4.96053 15.3973C4.84926 15.3507 4.74175 15.2995 4.63331 15.2478L4.59952 15.2316C4.57142 15.2183 4.54328 15.2052 4.51515 15.1921C4.4335 15.154 4.35194 15.1159 4.27164 15.0734C4.15533 15.0113 4.04283 14.9436 3.93023 14.8757L3.89806 14.8563L3.85165 14.8279L3.85149 14.8278C3.77381 14.7802 3.69614 14.7326 3.62044 14.6849C3.4868 14.597 3.35887 14.5016 3.23094 14.4062L3.23092 14.4062L3.2309 14.4062L3.23087 14.4062C3.15661 14.3536 3.08121 14.2965 3.00867 14.2394C2.90314 14.1534 2.80177 14.0626 2.70132 13.9726L2.61624 13.8966C2.59564 13.8778 2.57439 13.8599 2.5531 13.8421L2.55307 13.842L2.55306 13.842C2.52594 13.8193 2.49878 13.7965 2.47286 13.7715C2.47049 13.7694 2.46889 13.7666 2.46726 13.7637C2.46574 13.761 2.46421 13.7583 2.46201 13.7561C0.10539 11.4982 -0.640628 8.03353 0.577834 5.00569ZM9.10759 7.69552C9.11102 7.69209 9.11445 7.69209 9.1173 7.69209C10.0229 7.18283 10.471 6.12662 10.2078 5.12145C9.94458 4.11629 9.03641 3.41526 7.99743 3.41526C6.95845 3.41526 6.05027 4.11629 5.78707 5.12145C5.52387 6.12662 5.97192 7.18283 6.87755 7.69209L6.88783 7.69552C7.0393 7.77985 7.1994 7.84765 7.36537 7.89775C7.37982 7.90169 7.39331 7.90624 7.40661 7.91072L7.40664 7.91073L7.40665 7.91074C7.42224 7.916 7.43758 7.92116 7.45391 7.92517C7.50578 7.9384 7.55947 7.948 7.61093 7.9572L7.62985 7.96059C7.74065 7.97996 7.85271 7.99122 7.96515 7.99429H8.03027C8.14271 7.99122 8.25478 7.97996 8.36558 7.96059L8.37228 7.95942C8.42896 7.94952 8.48656 7.93946 8.54151 7.92517C8.56023 7.92075 8.57753 7.9149 8.59474 7.90909C8.60642 7.90514 8.61805 7.90121 8.63005 7.89775C8.79602 7.84765 8.95612 7.77985 9.10759 7.69552ZM9.45261 8.81177C11.2936 9.43416 12.5419 11.1501 12.5675 13.0934L12.5441 13.1148C12.5283 13.1293 12.5126 13.1438 12.4961 13.158C12.3921 13.2494 12.2847 13.3362 12.1762 13.4202C12.1122 13.4693 12.0482 13.5179 11.9825 13.5647C11.8792 13.6395 11.7741 13.7104 11.6672 13.7784C11.5896 13.8281 11.5101 13.876 11.4302 13.9229C11.3296 13.98 11.2274 14.0371 11.124 14.0943C11.0326 14.1411 10.9395 14.1851 10.8458 14.2285C10.7521 14.2719 10.6487 14.3182 10.5476 14.3588C10.4465 14.3993 10.3391 14.4376 10.2335 14.473L10.1839 14.4901C10.1039 14.5177 10.0237 14.5454 9.94272 14.5696C9.84003 14.6004 9.73318 14.6261 9.62675 14.6517L9.59085 14.6604C9.56177 14.6672 9.53281 14.6743 9.50385 14.6814C9.44065 14.6969 9.37748 14.7124 9.31323 14.7249C9.18537 14.7498 9.05496 14.7674 8.92393 14.7852L8.90081 14.7883C8.87026 14.7923 8.8398 14.7969 8.80932 14.8015L8.80929 14.8015C8.76114 14.8088 8.71295 14.816 8.66433 14.8209C8.44498 14.842 8.22277 14.8546 7.99828 14.8546C7.77379 14.8546 7.55159 14.842 7.33224 14.8209C7.28362 14.816 7.23543 14.8088 7.18727 14.8015L7.18724 14.8015C7.15677 14.7969 7.1263 14.7923 7.09575 14.7883L7.07264 14.7852C6.94161 14.7674 6.81119 14.7498 6.68333 14.7249C6.61909 14.7124 6.55592 14.6969 6.49272 14.6814L6.49261 14.6814C6.46369 14.6743 6.43476 14.6672 6.40572 14.6604C6.28748 14.6318 6.1698 14.6033 6.05385 14.5696C5.97288 14.5454 5.8927 14.5177 5.81265 14.4901L5.81264 14.4901L5.76309 14.473C5.65742 14.4364 5.55174 14.3993 5.44892 14.3588C5.3461 14.3182 5.249 14.2736 5.15075 14.2285C5.0525 14.1834 4.96396 14.1411 4.87256 14.0943C4.76917 14.0406 4.66692 13.984 4.56639 13.9229C4.48642 13.876 4.40702 13.8281 4.32933 13.7784C4.22251 13.7104 4.11741 13.6395 4.01402 13.5647C3.94832 13.5179 3.88435 13.4693 3.82037 13.4202C3.71184 13.3362 3.60445 13.2488 3.50049 13.158C3.48411 13.1457 3.4687 13.1312 3.45315 13.1166C3.44485 13.1088 3.4365 13.101 3.42794 13.0934C3.45349 11.1501 4.70181 9.43416 6.54281 8.81177C7.46332 9.24971 8.5321 9.24971 9.45261 8.81177ZM10.5225 8.02286C12.0884 8.80112 13.2143 10.2507 13.5808 11.9606C14.4078 10.8047 14.8524 9.419 14.8524 7.99772C14.8539 5.03815 12.9551 2.4121 10.1443 1.48631C7.33347 0.56051 4.24595 1.54424 2.48864 3.92552C0.731331 6.30679 0.701469 9.54733 2.4146 11.9606C2.78117 10.2507 3.90702 8.80112 5.47291 8.02286C4.21856 6.65635 4.27887 4.53984 5.60899 3.24698C6.93911 1.95413 9.05631 1.95413 10.3864 3.24698C11.7166 4.53984 11.7769 6.65635 10.5225 8.02286Z"
                />
              </svg>
              {{ usernameInfo || "My Account" }}
            </div>
          </router-link>
        </li>
        <!-- <li>
          <router-link v-on:click.native="openSideNav()" to="/profile/myspecialscreening"
            v-bind:class="['djhsajdh ',$route.path == 'myspecialscreening' ? 'active': '']">
            <div>
              <svg width="16" height="19" viewBox="0 0 16 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M6.92966 10.9379L9.47993 9.95893C9.78961 9.84005 9.93551 9.51234 9.81664 9.20266C9.69777 8.89299 9.37005 8.74708 9.06038 8.86595L6.51011 9.84491C6.20043 9.96378 6.05453 10.2915 6.1734 10.6012C6.29227 10.9108 6.61999 11.0568 6.92966 10.9379Z">
                </path>
                <path
                  d="M10.9924 10.6327L6.07407 12.5207C5.7644 12.6396 5.61849 12.9673 5.73736 13.277C5.85624 13.5866 6.18395 13.7325 6.49363 13.6137L11.412 11.7257C11.7217 11.6068 11.8676 11.2791 11.7487 10.9694C11.6298 10.6597 11.3021 10.5138 10.9924 10.6327Z">
                </path>
                <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M8.92594 0.349043L6.79464 1.16717C6.53962 1.26507 6.37273 1.53813 6.43419 1.80714C6.56964 2.48667 6.16852 3.18405 5.51274 3.43578C4.85696 3.68751 4.11045 3.43066 3.7382 2.84204C3.60387 2.601 3.29713 2.50974 3.04211 2.60764L0.91081 3.42576C0.400756 3.62155 0.153836 4.17615 0.349627 4.6862L5.38426 17.8019C5.58005 18.3119 6.13464 18.5588 6.6447 18.363L8.57561 17.6218C8.84886 17.517 9.00176 17.2075 8.9333 16.9202C8.74045 16.2 9.11359 15.4298 9.80581 15.1641C10.5162 14.8914 11.3272 15.2071 11.6475 15.8783C11.7706 16.1446 12.0913 16.2723 12.3828 16.1604L14.6598 15.2863C15.1699 15.0905 15.4168 14.5359 15.221 14.0259L10.1864 0.910226C9.99059 0.400172 9.43599 0.153252 8.92594 0.349043ZM3.0609 3.85444C3.77485 4.6254 4.91219 4.92034 5.93229 4.52875C6.9524 4.13717 7.61847 3.14998 7.61495 2.10631L9.16333 1.51194L10.4919 4.97302L2.84111 7.90989L1.51252 4.44881L3.0609 3.85444ZM9.38626 14.0711C10.461 13.6585 11.7062 14.0166 12.4004 14.8996L14.0581 14.2633L10.9115 6.06599L3.26066 9.00286L6.40731 17.2002L7.71887 16.6967C7.64396 15.5759 8.3115 14.4837 9.38626 14.0711Z">
                </path>
              </svg>
              My Special Screening
            </div>
          </router-link>
        </li>-->
        <li>
          <router-link
            v-on:click.native="
              openSideNav();
              checkSignIn();
            "
            :to="isUserLoggedIn ? '/profile/myNotification' : '#'"
            v-bind:class="[$route.path == 'myNotification' ? 'active' : '']"
          >
            <div>
              <svg
                width="16"
                height="18"
                viewBox="0 0 16 18"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M16 11.6923C16 12.7112 15.1714 13.5385 14.1508 13.5385H1.8492C0.827975 13.5385 0 12.7124 0 11.6923C0 10.6736 0.827281 9.84615 1.8468 9.84615C1.8456 9.84615 1.84615 6.15361 1.84615 6.15361C1.84615 2.75418 4.6009 0 8 0C11.3991 0 14.1538 2.75484 14.1538 6.15361V9.84562C15.1712 9.84615 16 10.6733 16 11.6923ZM14.1532 11.0769C13.4732 11.0769 12.9231 10.5271 12.9231 9.84562V6.15361C12.9231 3.43456 10.7194 1.23077 8 1.23077C5.28058 1.23077 3.07692 3.43398 3.07692 6.15361V9.84562C3.07692 10.5252 2.5255 11.0769 1.8468 11.0769C1.50709 11.0769 1.23077 11.3533 1.23077 11.6923C1.23077 12.032 1.50709 12.3077 1.8492 12.3077H14.1508C14.4921 12.3077 14.7692 12.031 14.7692 11.6923C14.7692 11.3536 14.492 11.0769 14.1532 11.0769ZM6.46154 14.4615H5.23077C5.23077 15.9909 6.4706 17.2308 8 17.2308C9.5294 17.2308 10.7692 15.9909 10.7692 14.4615H9.53846C9.53846 15.3112 8.84967 16 8 16C7.15033 16 6.46154 15.3112 6.46154 14.4615Z"
                />
              </svg>
              Notification
            </div>
          </router-link>
        </li>
        <!-- <li>
          <router-link v-on:click.native="openSideNav()" to="/profile/myFavourites"
            v-bind:class="[$route.path == 'myFavourites' ? 'active': '']">
            <div>
              <svg width="16" height="15" viewBox="0 0 16 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M1.94334 10.5722C1.30123 14.1913 3.97746 16.0706 7.33766 14.3623L7.99994 14.0257L8.66221 14.3623C12.0232 16.071 14.6986 14.1904 14.0565 10.5722L13.9301 9.85932L14.466 9.3544C17.1849 6.79134 16.162 3.74972 12.4055 3.22188L11.6649 3.11791L11.3338 2.46926C9.65329 -0.823509 6.34581 -0.822667 4.66609 2.46926L4.33496 3.11791L3.59436 3.22188C-0.162899 3.74991 -1.18422 6.79199 1.53388 9.3544L2.06974 9.85932L1.94334 10.5722ZM9.24382 13.2918L7.99994 12.6593L6.75605 13.2918C4.31324 14.5334 2.70875 13.4082 3.1756 10.7767L3.41367 9.43706L2.40708 8.48836C0.431128 6.62602 1.04222 4.80277 3.77428 4.41884L5.16551 4.22332L5.78746 3.00449C7.00808 0.611884 8.99024 0.610294 10.2124 3.00449L10.8344 4.22332L12.2256 4.41884C14.9553 4.80249 15.5695 6.62471 13.5928 8.48836L12.5862 9.43706L12.8235 10.7767C13.2903 13.4064 11.6874 14.5342 9.24382 13.2918Z">
                </path>
              </svg>
              My Favourites
            </div>
          </router-link>
        </li>-->
        <li>
          <router-link
            v-on:click.native="
              openSideNav();
              checkSignIn();
            "
            :to="isUserLoggedIn ? '/profile/myTransaction' : '#'"
            v-bind:class="[$route.path == 'myTransaction' ? 'active' : '']"
          >
            <div>
              <svg
                width="19"
                height="16"
                viewBox="0 0 19 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M4.97927 0H15.9739C17.2369 0.00205197 18.2602 1.02539 18.2623 2.28838V3.54624C18.2623 3.80353 18.0537 4.01211 17.7964 4.01211H14.6154V13.7116C14.6134 14.9746 13.59 15.9979 12.327 16H2.28838C1.02539 15.9979 0.00205197 14.9746 0 13.7116V12.4538C0 12.1965 0.208579 11.9879 0.465875 11.9879H2.66853V2.31074C2.66956 1.03498 3.70351 0.0010276 4.97927 0ZM0.931749 13.7116C0.932776 14.4604 1.53956 15.0672 2.28838 15.0683H10.4859C10.1952 14.6757 10.0384 14.2001 10.0387 13.7116V12.9196H0.931749V13.7116ZM13.6837 2.28838V13.7116C13.6837 14.4614 13.0759 15.0692 12.3261 15.0692C11.5764 15.0692 10.9686 14.4614 10.9686 13.7116V12.4538C10.9686 12.1965 10.76 11.9879 10.5027 11.9879H3.59469V2.31074C3.59572 1.54957 4.21251 0.932776 4.97368 0.931749H14.1346C13.8423 1.3237 13.6842 1.79944 13.6837 2.28838ZM14.6154 3.08036H17.3305V2.28838C17.3305 1.53862 16.7227 0.930818 15.973 0.930818C15.2232 0.930818 14.6154 1.53862 14.6154 2.28838V3.08036ZM8.03913 5.34265C8.1096 5.4442 8.13682 5.5696 8.1148 5.69122C8.09278 5.81285 8.02333 5.92074 7.92173 5.99115C7.30352 6.42047 6.76708 6.95691 6.33776 7.57512C6.25259 7.6986 6.11317 7.77351 5.9632 7.77638H5.9427C5.78329 7.76959 5.63845 7.6817 5.55882 7.54344C5.40162 7.26823 5.17391 7.03988 4.89914 6.8819C4.67821 6.75239 4.60325 6.46883 4.7313 6.24706C4.85934 6.02528 5.14239 5.94843 5.36501 6.07501C5.58536 6.20209 5.78673 6.35954 5.9632 6.54274C6.38066 6.04147 6.86395 5.59892 7.39995 5.22711C7.60916 5.08626 7.89247 5.13747 8.03913 5.34265ZM12.1481 6.92662C12.4054 6.92662 12.614 6.71805 12.614 6.46075C12.614 6.20345 12.4054 5.99488 12.1481 5.99488H9.52434C9.26705 5.99488 9.05847 6.20345 9.05847 6.46075C9.05847 6.71805 9.26705 6.92662 9.52434 6.92662H12.1481ZM4.7277 3.33007C4.78869 3.22253 4.88993 3.14365 5.00912 3.11079C5.12831 3.07794 5.25567 3.09381 5.36315 3.1549C5.58386 3.28078 5.78584 3.43697 5.9632 3.61891C6.38064 3.11763 6.86393 2.67508 7.39995 2.30328C7.61145 2.15663 7.90179 2.20919 8.04845 2.42068C8.19511 2.63218 8.14255 2.92252 7.93105 3.06918C7.30948 3.49525 6.76924 4.02918 6.3359 4.6457C6.25234 4.77077 6.11354 4.84781 5.9632 4.85255H5.9427C5.78329 4.84576 5.63845 4.75787 5.55882 4.61961C5.40218 4.3478 5.17655 4.12216 4.90473 3.96553C4.79687 3.90484 4.71759 3.80374 4.68438 3.68453C4.65117 3.56531 4.66675 3.43778 4.7277 3.33007ZM12.1481 3.99348C12.4054 3.99348 12.614 3.7849 12.614 3.5276C12.614 3.27031 12.4054 3.06173 12.1481 3.06173H9.52434C9.26705 3.06173 9.05847 3.27031 9.05847 3.5276C9.05847 3.7849 9.26705 3.99348 9.52434 3.99348H12.1481ZM8.03913 8.26648C8.18625 8.47748 8.13453 8.76777 7.9236 8.91498C7.30541 9.34433 6.76898 9.88077 6.33962 10.499C6.25407 10.623 6.11383 10.6979 5.9632 10.7002H5.9427C5.78329 10.6934 5.63845 10.6055 5.55882 10.4673C5.40211 10.1955 5.17649 9.96989 4.90473 9.81318C4.7594 9.73056 4.66948 9.57639 4.66912 9.40922C4.66875 9.24204 4.75799 9.08748 4.90295 9.00422C5.04792 8.92095 5.22638 8.92174 5.3706 9.00629C5.58849 9.13155 5.78792 9.28646 5.9632 9.46657C6.38012 8.96546 6.86277 8.52292 7.39809 8.15094C7.60766 8.00886 7.89235 8.06017 8.03913 8.26648ZM12.1481 9.85045C12.4054 9.85045 12.614 9.64188 12.614 9.38458V9.38272C12.613 9.12615 12.4047 8.9187 12.1481 8.9187H9.52434C9.26705 8.9187 9.05847 9.12728 9.05847 9.38458C9.05847 9.64188 9.26705 9.85045 9.52434 9.85045H12.1481Z"
                />
              </svg>
              My Transaction
            </div>
          </router-link>
        </li>
        <!-- <li>
          <router-link
            v-on:click.native="openSideNav()"
            :to="isUserLoggedIn ? '/profile/myWallet' : '#'"
            v-bind:class="[$route.path == 'myWallet' ? 'active': '']"
          >
            <div>
              <svg
                width="16"
                height="15"
                viewBox="0 0 16 15"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M15.4286 14.8569H2.28571C1.02514 14.8569 0 13.8317 0 12.5711V1.71401C0 1.39858 0.256 1.14258 0.571429 1.14258C0.886857 1.14258 1.14286 1.39858 1.14286 1.71401V12.5711C1.14286 13.202 1.656 13.714 2.28571 13.714H14.8571V2.85686C14.8571 2.54144 15.1131 2.28544 15.4286 2.28544C15.744 2.28544 16 2.54144 16 2.85686V14.2854C16 14.6009 15.744 14.8569 15.4286 14.8569Z"
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M1.71429 3.42857H12C12.3154 3.42857 12.5714 3.17257 12.5714 2.85714V0.571429C12.5714 0.256 12.3154 0 12 0H1.71429C0.769143 0 0 0.769143 0 1.71429C0 2.65943 0.769143 3.42857 1.71429 3.42857ZM1.14286 1.71429C1.14286 1.39886 1.39886 1.14286 1.71429 1.14286H11.4286V2.28571H1.71429C1.39886 2.28571 1.14286 2.02971 1.14286 1.71429Z"
                />
                <path
                  d="M15.4285 3.42801H11.9999C11.6845 3.42801 11.4285 3.17201 11.4285 2.85658C11.4285 2.54116 11.6845 2.28516 11.9999 2.28516H15.4285C15.7439 2.28516 15.9999 2.54116 15.9999 2.85658C15.9999 3.17201 15.7439 3.42801 15.4285 3.42801Z"
                />
                <path
                  d="M15.4285 10.286H11.9999C11.0548 10.286 10.2856 9.51685 10.2856 8.57171C10.2856 7.62656 11.0548 6.85742 11.9999 6.85742H15.4285C15.7439 6.85742 15.9999 7.11342 15.9999 7.42885C15.9999 7.74428 15.7439 8.00028 15.4285 8.00028H11.9999C11.6856 8.00028 11.4285 8.25742 11.4285 8.57171C11.4285 8.88599 11.6856 9.14314 11.9999 9.14314H15.4285C15.7439 9.14314 15.9999 9.39914 15.9999 9.71456C15.9999 10.03 15.7439 10.286 15.4285 10.286Z"
                />
              </svg>
              My Wallet
            </div>
          </router-link>
        </li>-->
        <!-- <li>
          <router-link
            v-on:click.native="openSideNav()"
            :to="isUserLoggedIn ? '/profile/offers-promotions' : '#'"
            v-bind:class="[$route.path == 'offers-promotions' ? 'active': '']"
          >
            <div>
              <svg
                width="17"
                height="16"
                viewBox="0 0 17 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M16 9.85673C16.3897 9.44413 16.8711 8.82521 16.8711 8.02292C16.8711 7.22063 16.3668 6.60172 16 6.18911C15.9398 6.10484 15.8606 6.00161 15.7924 5.9126C15.7307 5.83214 15.6779 5.76331 15.6562 5.73066C15.6256 5.65425 15.6358 5.49634 15.646 5.33843C15.6511 5.25947 15.6562 5.18052 15.6562 5.11175C15.702 4.53868 15.7249 3.75931 15.2665 3.11748C14.808 2.47564 14.0287 2.26934 13.4556 2.15473C13.429 2.14808 13.3996 2.14096 13.3684 2.13342L13.3684 2.13342C13.1845 2.08895 12.9413 2.03015 12.8825 1.97135C12.8416 1.93041 12.7682 1.81636 12.6912 1.6969L12.6912 1.69687L12.6912 1.69684L12.6912 1.69682C12.6389 1.61563 12.585 1.53196 12.5387 1.46705C12.2407 0.962751 11.8052 0.320917 11.0487 0.0916905C10.8424 0 10.659 0 10.4298 0C9.90258 0 9.4212 0.183381 9.05444 0.34384C8.87106 0.412607 8.55014 0.527221 8.43553 0.527221C8.3456 0.527221 8.14277 0.456656 7.95991 0.393043C7.90973 0.375584 7.86105 0.358649 7.81662 0.34384L7.78605 0.331947C7.3814 0.174461 6.93314 0 6.44126 0C6.31901 0 6.17638 0.0203757 6.03375 0.0407514C5.96243 0.0509392 5.89112 0.061127 5.82235 0.0687679C5.0659 0.34384 4.63037 0.985673 4.33238 1.44413C4.27507 1.52435 4.20631 1.62751 4.14327 1.72206L4.14326 1.72207C4.08023 1.81662 4.02292 1.90258 3.98854 1.94842C3.91977 2.04011 3.59885 2.10888 3.41547 2.13181C3.34474 2.15333 3.26946 2.17445 3.19092 2.19648C2.68407 2.33866 2.04122 2.51899 1.60458 3.09456C1.1591 3.71823 1.18979 4.47176 1.21291 5.03969L1.2149 5.08883C1.2149 5.1476 1.21961 5.22285 1.2245 5.301C1.23487 5.4667 1.24605 5.64543 1.2149 5.70774C1.16905 5.7765 0.985673 6.05158 0.87106 6.16619C0.481375 6.5788 0 7.19771 0 8C0 8.80229 0.504298 9.4212 0.87106 9.83381C0.931216 9.91803 1.01031 10.0212 1.07853 10.1102L1.0786 10.1103L1.07861 10.1103L1.07866 10.1103L1.07868 10.1103L1.07868 10.1104C1.14037 10.1908 1.19313 10.2596 1.2149 10.2923C1.24546 10.3687 1.23528 10.5266 1.22509 10.6845C1.21999 10.7635 1.2149 10.8424 1.2149 10.9112C1.16905 11.4842 1.14613 12.2636 1.60458 12.9054C2.06304 13.5473 2.84241 13.7536 3.41547 13.8682C3.44185 13.8748 3.47107 13.8819 3.50197 13.8893L3.50261 13.8895L3.5027 13.8895C3.68659 13.934 3.92974 13.9928 3.98854 14.0516C4.02949 14.0925 4.10295 14.2066 4.17988 14.3261L4.1799 14.3261L4.1799 14.3262L4.17991 14.3262L4.17993 14.3262L4.17994 14.3262C4.23219 14.4074 4.28603 14.491 4.33238 14.5559C4.63037 15.0602 5.0659 15.702 5.82235 15.9312C6.00573 16 6.21203 16 6.44126 16C6.96848 16 7.44986 15.8166 7.81662 15.6562C8 15.5874 8.32092 15.4728 8.43553 15.4728C8.52546 15.4728 8.72828 15.5433 8.91112 15.6069L8.91114 15.607L8.91122 15.607C8.96138 15.6244 9.01003 15.6414 9.05444 15.6562L9.085 15.6681C9.48965 15.8255 9.93792 16 10.4298 16C10.5521 16 10.6947 15.9796 10.8373 15.9592C10.9086 15.9491 10.9799 15.9389 11.0487 15.9312C11.8052 15.6562 12.2407 15.0143 12.5387 14.5559C12.596 14.4756 12.6648 14.3725 12.7278 14.2779C12.7908 14.1834 12.8481 14.0974 12.8825 14.0516C12.9513 13.9828 13.2722 13.8911 13.4556 13.8682C13.5263 13.8467 13.6016 13.8256 13.6801 13.8035C14.187 13.6613 14.8298 13.481 15.2665 12.9054C15.712 12.2818 15.6813 11.5282 15.6581 10.9603L15.6562 10.9112C15.6562 10.8524 15.6515 10.7772 15.6466 10.699V10.699C15.6362 10.5333 15.625 10.3546 15.6562 10.2923C15.6671 10.2705 15.7195 10.2071 15.7838 10.1294L15.7838 10.1294L15.7839 10.1294C15.8547 10.0438 15.9399 9.94082 16 9.85673ZM14.8921 9.17229L14.892 9.17246C14.6876 9.4138 14.4709 9.66965 14.3725 9.9255C14.2724 10.2256 14.2947 10.5607 14.3172 10.9002C14.3204 10.9497 14.3237 10.9992 14.3266 11.0487C14.3725 11.4613 14.3954 11.9198 14.212 12.1719C14.0287 12.447 13.5931 12.5616 13.1805 12.6304C12.7908 12.6991 12.4241 12.8138 12.149 13.0201C11.8739 13.2034 11.6447 13.5473 11.4613 13.8682C11.2321 14.2579 11.0029 14.6017 10.659 14.7163C10.5903 14.7622 10.5444 14.7622 10.4756 14.7622C10.2006 14.7622 9.90258 14.6476 9.60458 14.4871C9.26075 14.3266 8.87106 14.1891 8.48138 14.1891C8.16331 14.1891 7.87578 14.296 7.56894 14.4101C7.49985 14.4358 7.42978 14.4618 7.35817 14.4871C7.2938 14.5119 7.22836 14.5388 7.16277 14.5657C6.92474 14.6636 6.68479 14.7622 6.48711 14.7622C6.41834 14.7622 6.32665 14.7622 6.30373 14.7163C6.00573 14.6017 5.73066 14.212 5.50143 13.8682C5.31805 13.5702 5.08883 13.2264 4.81375 13.0201C4.51576 12.8367 4.17192 12.7221 3.78223 12.6304C3.71616 12.612 3.6495 12.5948 3.58338 12.5778L3.58329 12.5778C3.23655 12.4884 2.90472 12.4029 2.75072 12.1719C2.56734 11.8968 2.59026 11.4842 2.6361 11.0487C2.68195 10.659 2.68195 10.2923 2.56734 9.9255C2.45272 9.62751 2.2235 9.30659 1.94842 9.05444L1.88862 8.98567C1.60907 8.66476 1.32951 8.34384 1.32951 8.02292C1.32951 7.70364 1.58646 7.38436 1.8434 7.06509L1.90258 6.9914C1.935 6.9525 1.96833 6.91314 2.002 6.87339C2.2064 6.63204 2.42309 6.37619 2.52149 6.12034C2.62154 5.82021 2.59932 5.48514 2.57681 5.14563C2.57353 5.0962 2.57025 5.04667 2.56734 4.99713C2.52149 4.58453 2.49857 4.12607 2.68195 3.87393C2.86533 3.59885 3.30086 3.48424 3.71347 3.41547C4.10315 3.3467 4.46991 3.23209 4.74499 3.02579C5.02006 2.81948 5.24928 2.49857 5.43266 2.17765C5.66189 1.78797 5.89112 1.44413 6.23496 1.32951C6.30372 1.28367 6.34957 1.28367 6.41834 1.28367C6.69341 1.28367 6.9914 1.39828 7.2894 1.55874C7.63324 1.7192 8.02292 1.85673 8.41261 1.85673C8.73067 1.85673 9.0182 1.74983 9.32504 1.63575C9.39413 1.61007 9.4642 1.58402 9.53582 1.55874C9.60019 1.53398 9.66563 1.50708 9.73121 1.48013C9.96925 1.38229 10.2092 1.28367 10.4069 1.28367C10.4756 1.28367 10.5673 1.28367 10.5903 1.32951C10.8883 1.44413 11.1633 1.83381 11.3925 2.17765C11.5759 2.47564 11.8052 2.81948 12.0802 3.02579C12.3782 3.20917 12.7221 3.32378 13.1117 3.41547C13.1778 3.43383 13.2445 3.45102 13.3107 3.46806L13.3107 3.46807C13.6574 3.55742 13.9893 3.64292 14.1433 3.87393C14.3266 4.149 14.3037 4.5616 14.2579 4.99713C14.212 5.38682 14.212 5.75358 14.3037 6.12034C14.4183 6.41834 14.6476 6.73925 14.9226 6.9914L14.9818 7.06508C15.2388 7.38436 15.4957 7.70364 15.4957 8.02292C15.5604 8.34654 15.3003 8.67015 15.0401 8.99376L14.9914 9.05444C14.9593 9.09293 14.9264 9.13186 14.8931 9.17118L14.893 9.17123L14.8929 9.17142L14.8922 9.17216L14.8921 9.17229ZM9.16905 9.37536C9.16905 7.95415 9.67335 7.26648 10.7049 7.26648C11.1862 7.26648 11.5759 7.44986 11.8281 7.7937C12.0802 8.18338 12.2407 8.68768 12.2407 9.37536C12.2407 10.086 12.1261 10.6132 11.851 10.957C11.5759 11.3009 11.2092 11.4842 10.7049 11.4842C10.2006 11.4842 9.83381 11.3009 9.55874 10.957C9.28367 10.5673 9.16905 10.063 9.16905 9.37536ZM10.7049 10.5215C10.5444 10.5215 10.4298 10.4527 10.4069 10.2464C10.3381 10.063 10.2923 9.74212 10.2923 9.37536C10.2923 9.0086 10.3381 8.68768 10.4069 8.5043C10.4756 8.32092 10.5903 8.22923 10.7049 8.22923C10.9799 8.22923 11.1175 8.61891 11.1175 9.37536C11.1633 10.1318 11.0029 10.5215 10.7049 10.5215ZM7.70201 6.67049C7.70201 7.38109 7.58739 7.90831 7.31232 8.25215C7.06017 8.64183 6.67049 8.77937 6.14327 8.77937C5.63897 8.77937 5.27221 8.59599 4.99713 8.25215C4.72206 7.90831 4.60745 7.35817 4.60745 6.67049C4.60745 5.24928 5.11175 4.5616 6.14327 4.5616C6.64756 4.5616 7.01433 4.74499 7.2894 5.08883C7.54155 5.47851 7.70201 5.98281 7.70201 6.67049ZM5.82235 7.56447C5.75358 7.38109 5.70774 7.06017 5.70774 6.69341C5.70774 6.32665 5.75358 6.00573 5.82235 5.82235C5.89112 5.63897 6.00573 5.54728 6.12034 5.54728C6.39542 5.54728 6.53295 5.93696 6.53295 6.69341C6.53295 7.44986 6.37249 7.83954 6.12034 7.83954C6.02865 7.83954 5.91404 7.74785 5.82235 7.56447ZM6.09742 11.3925L9.69627 4.67622H10.7736L7.17479 11.3925H6.09742Z"
                />
              </svg>
              Offers &amp; Promotions
            </div>
          </router-link>
        </li>-->
      </ul>
      <hr />
      <ul class="sidebar-list">
        <li>
          <router-link v-on:click.native="openSideNav()" to="/hiw"
            >How it Works</router-link
          >
        </li>
        <li>
          <router-link v-on:click.native="openSideNav()" to="/aboutUs"
            >About Us</router-link
          >
          <!-- <router-link v-on:click.native="openSideNav()" to="/coming-soon">About Us</router-link> -->
        </li>
        <li>
          <router-link v-on:click.native="openSideNav()" to="/faqs"
            >FAQs</router-link
          >
        </li>
        <!-- <li>
          <div v-if="countryData" v-on:click="onClickCountrySelector()">
            <img src="@/assets/img/icon-location.png" width="20px" alt />
            {{countryData.CountryName}}
          </div>
        </li>-->
        <li>
          <router-link v-if="isUserLoggedIn" @click.native="onLogout()" to="#"
            >Logout</router-link
          >
        </li>
      </ul>
      <hr />
      <div class="small text-center">
        &copy; {{ DATEYEAR }} {{ TITLE }}, All Rights Reserved
      </div>
    </aside>
    <div class="backdrop" v-if="backdrop" @click="openSideNav()"></div>
    <section class="containier-fluid bg-color">
      <header>
        <b-navbar toggleable="lg" type="dark" class="">
          <b-navbar-brand @click="Redirect" style="cursor: pointer">
            <img
              src="@/assets/img/svg/gogo-logo.svg"
              style="max-width: 110px"
            />
            <!-- <span class="pl-4"><img src="@/assets/img/svg/home.svg" ></span> v-on:click="setCountry(country)"-->
          </b-navbar-brand>
          <div class="d-flex align-items-center d-lg-none">
            <div class="d-flex align-items-center sc-dropdown" v-if="false">
              <!-- <img :src="imageCountry" width="22" height="16" /> -->
              <b-dropdown
                :text="CountryText"
                class="countrySelectionDropdown"
                variant="transparent"
                right
              >
                <b-dropdown-item
                  v-for="(country, index) in countries"
                  :index="index"
                  :key="index"
                  v-on:click="setCountry(country)"
                >
                  <!-- <img
                    :src="country.CountryFlag"
                    class="flag-class mr-1"
                    height="auto"
                    width="40"
                  /> -->
                  {{ country.country_name }}
                </b-dropdown-item>
              </b-dropdown>
            </div>
            <img
              src="@/assets/img/svg/mob-search-icon.svg"
              v-on:click="openSearch(true)"
              width="25px"
              class="mr-2"
              height="auto"
            />
            <button
              class="navbar-toggler"
              v-on:click="openSideNav()"
              style="border: none !important"
            >
              <span class="navbar-toggler-icon"></span>
            </button>
          </div>
          <b-collapse is-nav id="nav_collapse">
            <div
              class="
                col-12 col-md-5 col-lg-4 col-xl-4
                ml-md-4 ml-lg-3 ml-xl-5
                px-0
                grp-drop
              "
            >
              <b-input-group class="pr-3">
                <b-button variant="default" class="pr-1">
                  <img
                    src="@/assets/img/icons/Shape.png"
                    height="19"
                    width="19"
                  />
                </b-button>
                <b-form-input
                  v-debounce:500="searchData"
                  v-model="searchValue"
                  placeholder="Search for movie"
                  class="px-1"
                />
                <b-dropdown
                  v-if="Regions"
                  class="d-none d-md-block"
                  :text="selectedRegion"
                  variant="default"
                  slot="append"
                >
                  <b-dropdown-item
                    v-on:click="onChangeRegion(region)"
                    v-for="(region, regionIndex) in Regions"
                    :key="regionIndex"
                    >{{ region.region_name }}</b-dropdown-item
                  >
                </b-dropdown>
                <!-- <b-dropdown class="d-block d-md-none" text variant="default" slot="append">
                  <b-dropdown-item>Clementi (Singapore)</b-dropdown-item>
                  <b-dropdown-item>Clementi (Singapore)</b-dropdown-item>
                </b-dropdown>-->
              </b-input-group>
              <ul class="searchListData" v-if="searchValue">
                <li
                  v-for="(movie, movieListIndex) in movieListSearch"
                  :key="movieListIndex"
                >
                  <router-link
                    @click.native="() => (searchValue = null)"
                    :to="{
                      name: 'createScreen',
                      params: {
                        movie_id: movie.movie_id,
                        content_lang_id: movie.content_lang_id,
                      },
                    }"
                    >{{ movie.movie_title }}</router-link
                  >
                </li>
              </ul>
            </div>
            <!-- Right aligned nav items -->
            <b-navbar-nav class="ml-auto">
              <router-link
                to
                @click.native="Redirect"
                class="px-lg-1 px-xl-2 text-white hA"
                >Home</router-link
              >
              <router-link to="/aboutUs" class="px-lg-1 px-xl-2 text-white hA"
                >About Us</router-link
              >

              <router-link to="/hiw" class="px-lg-1 px-xl-2 text-white hA"
                >How it Works</router-link
              >
              <router-link to="/faqs" class="px-lg-1 px-xl-2 text-white hA"
                >FAQs</router-link
              >
              <div
                class="d-flex align-items-center ml-3 sc-dropdown"
                v-if="false"
              >
                <!-- <img :src="imageCountry" width="22" height="16" /> -->
                <b-dropdown
                  :text="CountryText"
                  class="countrySelectionDropdown"
                  variant="transparent"
                  right
                >
                  <b-dropdown-item
                    v-for="(country, index) in countries"
                    :index="index"
                    :key="index"
                    v-on:click="setCountry(country)"
                  >
                    <!-- <img
                      :src="country.CountryFlag"
                      class="flag-class mr-1"
                      height="auto"
                      width="40"
                    /> -->
                    {{ country.country_name }}
                  </b-dropdown-item>
                </b-dropdown>
              </div>
              <!-- <router-link v-if="countryData" @click.native="onClickCountrySelector()" to
                class="px-lg-1 px-xl-2 text-white hA">
                <img src="@/assets/img/icon-location.png" width="20px" />
                {{countryData.CountryName}}
              </router-link>-->
              <!-- Verify Your OTP Modal End-->
              <div
                class="d-flex align-items-center cus-log-sign"
                v-if="!isUserLoggedIn"
              >
                <div class="px-lg-1 px-xl-2">
                  <img
                    src="@/assets/img/svg/user-icon.svg"
                    class="img-fluid signIn-icon"
                  />
                </div>
                <div
                  to
                  class="px-0 text-white mr-1 c-pointer hA header-link"
                  v-b-modal.signup
                >
                  Signup /
                </div>
                <!-- <div to class="px-0 text-white mr-1 c-pointer" v-b-modal.verifyContact>Start browser /</div> -->
                <div
                  to
                  class="px-0 text-white c-pointer hA header-link"
                  v-b-modal.login
                >
                  Login
                </div>
              </div>
              <div class="d-flex align-items-center" v-if="isUserLoggedIn">
                <div class="pl-2">
                  <img src="@/assets/img/svg/user-icon.svg" class="img-fluid" />
                </div>
                <div class="px-2 text-white accDrop">
                  <b-dropdown
                    variant="default"
                    slot="trigger"
                    class="py-0"
                    ref="hovermenu"
                    right
                    no-caret
                    :text="usernameInfo || 'My Account'"
                  >
                    <ul class="profileMenu-list">
                      <li>
                        <router-link
                          @click.native="closeMenu()"
                          to="/profile/myaccount"
                          v-bind:class="[
                            $route.path == 'myaccount' ? 'active' : '',
                          ]"
                        >
                          <div>
                            <svg
                              width="16"
                              height="16"
                              viewBox="0 0 16 16"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                fill-rule="evenodd"
                                clip-rule="evenodd"
                                d="M0.577834 5.00569C1.7963 1.97785 4.73412 -0.00409475 7.99771 1.35e-05C11.2621 -0.00596662 14.2017 1.9753 15.4213 5.00357C16.641 8.03183 15.8952 11.4976 13.538 13.7561C13.5358 13.7583 13.5342 13.761 13.5327 13.7637C13.5318 13.7654 13.5308 13.767 13.5298 13.7686C13.529 13.7696 13.5281 13.7706 13.5271 13.7715C13.5012 13.7965 13.474 13.8193 13.4469 13.842L13.4469 13.842L13.4469 13.8421C13.4256 13.8599 13.4043 13.8778 13.3838 13.8966C13.2552 14.0154 13.1267 14.1308 12.9913 14.2394C12.9494 14.273 12.9066 14.3044 12.8636 14.3359C12.8321 14.3589 12.8005 14.382 12.7691 14.4062L12.7691 14.4062C12.6411 14.5016 12.5132 14.597 12.3795 14.6849C12.3172 14.7277 12.2536 14.7656 12.1897 14.8036C12.1604 14.821 12.1312 14.8384 12.1019 14.8563L12.0698 14.8757L12.0698 14.8757C11.9572 14.9436 11.8447 15.0113 11.7284 15.0734C11.6481 15.1159 11.5665 15.154 11.4848 15.1921C11.4567 15.2052 11.4286 15.2183 11.4005 15.2316L11.3252 15.2674L11.3251 15.2674C11.2304 15.3125 11.1356 15.3576 11.0395 15.3973C10.9404 15.4383 10.8341 15.4754 10.7351 15.51L10.735 15.51L10.6687 15.5333C10.6351 15.5452 10.6015 15.5573 10.5678 15.5695C10.4852 15.5995 10.4023 15.6295 10.3174 15.6555C10.2102 15.6878 10.1008 15.7143 9.99147 15.7407L9.9073 15.7612C9.85839 15.7722 9.80947 15.7848 9.76055 15.7974L9.76053 15.7974L9.76042 15.7974C9.69514 15.8142 9.62985 15.831 9.56457 15.844C9.42702 15.8715 9.28773 15.8902 9.14821 15.9089L9.08703 15.9172C9.05027 15.9223 9.01383 15.9282 8.97741 15.934L8.9774 15.934L8.97738 15.934C8.9159 15.944 8.85448 15.9539 8.79171 15.96C8.53009 15.9857 8.26618 16 8 16C7.73381 16 7.4699 15.9857 7.20828 15.96C7.14551 15.9539 7.08409 15.944 7.02261 15.934L7.02257 15.934C6.98616 15.9282 6.94972 15.9223 6.91296 15.9172L6.85179 15.9089C6.71227 15.8902 6.57298 15.8715 6.43542 15.844C6.35415 15.8283 6.27615 15.8081 6.19803 15.7879L6.19798 15.7879L6.19787 15.7879L6.19778 15.7879C6.16287 15.7789 6.12794 15.7698 6.09269 15.7612L6.00851 15.7407L6.00849 15.7407L6.00847 15.7407C5.8992 15.7143 5.78979 15.6878 5.68255 15.6555C5.59165 15.6277 5.50771 15.5972 5.41786 15.5646L5.41783 15.5646L5.33125 15.5333C5.2984 15.5215 5.26563 15.5101 5.23292 15.4987L5.23282 15.4986L5.2328 15.4986L5.23278 15.4986C5.14157 15.4668 5.05089 15.4351 4.96053 15.3973C4.84926 15.3507 4.74175 15.2995 4.63331 15.2478L4.59952 15.2316C4.57142 15.2183 4.54328 15.2052 4.51515 15.1921C4.4335 15.154 4.35194 15.1159 4.27164 15.0734C4.15533 15.0113 4.04283 14.9436 3.93023 14.8757L3.89806 14.8563L3.85165 14.8279L3.85149 14.8278C3.77381 14.7802 3.69614 14.7326 3.62044 14.6849C3.4868 14.597 3.35887 14.5016 3.23094 14.4062L3.23092 14.4062L3.2309 14.4062L3.23087 14.4062C3.15661 14.3536 3.08121 14.2965 3.00867 14.2394C2.90314 14.1534 2.80177 14.0626 2.70132 13.9726L2.61624 13.8966C2.59564 13.8778 2.57439 13.8599 2.5531 13.8421L2.55307 13.842L2.55306 13.842C2.52594 13.8193 2.49878 13.7965 2.47286 13.7715C2.47049 13.7694 2.46889 13.7666 2.46726 13.7637C2.46574 13.761 2.46421 13.7583 2.46201 13.7561C0.10539 11.4982 -0.640628 8.03353 0.577834 5.00569ZM9.10759 7.69552C9.11102 7.69209 9.11445 7.69209 9.1173 7.69209C10.0229 7.18283 10.471 6.12662 10.2078 5.12145C9.94458 4.11629 9.03641 3.41526 7.99743 3.41526C6.95845 3.41526 6.05027 4.11629 5.78707 5.12145C5.52387 6.12662 5.97192 7.18283 6.87755 7.69209L6.88783 7.69552C7.0393 7.77985 7.1994 7.84765 7.36537 7.89775C7.37982 7.90169 7.39331 7.90624 7.40661 7.91072L7.40664 7.91073L7.40665 7.91074C7.42224 7.916 7.43758 7.92116 7.45391 7.92517C7.50578 7.9384 7.55947 7.948 7.61093 7.9572L7.62985 7.96059C7.74065 7.97996 7.85271 7.99122 7.96515 7.99429H8.03027C8.14271 7.99122 8.25478 7.97996 8.36558 7.96059L8.37228 7.95942C8.42896 7.94952 8.48656 7.93946 8.54151 7.92517C8.56023 7.92075 8.57753 7.9149 8.59474 7.90909C8.60642 7.90514 8.61805 7.90121 8.63005 7.89775C8.79602 7.84765 8.95612 7.77985 9.10759 7.69552ZM9.45261 8.81177C11.2936 9.43416 12.5419 11.1501 12.5675 13.0934L12.5441 13.1148C12.5283 13.1293 12.5126 13.1438 12.4961 13.158C12.3921 13.2494 12.2847 13.3362 12.1762 13.4202C12.1122 13.4693 12.0482 13.5179 11.9825 13.5647C11.8792 13.6395 11.7741 13.7104 11.6672 13.7784C11.5896 13.8281 11.5101 13.876 11.4302 13.9229C11.3296 13.98 11.2274 14.0371 11.124 14.0943C11.0326 14.1411 10.9395 14.1851 10.8458 14.2285C10.7521 14.2719 10.6487 14.3182 10.5476 14.3588C10.4465 14.3993 10.3391 14.4376 10.2335 14.473L10.1839 14.4901C10.1039 14.5177 10.0237 14.5454 9.94272 14.5696C9.84003 14.6004 9.73318 14.6261 9.62675 14.6517L9.59085 14.6604C9.56177 14.6672 9.53281 14.6743 9.50385 14.6814C9.44065 14.6969 9.37748 14.7124 9.31323 14.7249C9.18537 14.7498 9.05496 14.7674 8.92393 14.7852L8.90081 14.7883C8.87026 14.7923 8.8398 14.7969 8.80932 14.8015L8.80929 14.8015C8.76114 14.8088 8.71295 14.816 8.66433 14.8209C8.44498 14.842 8.22277 14.8546 7.99828 14.8546C7.77379 14.8546 7.55159 14.842 7.33224 14.8209C7.28362 14.816 7.23543 14.8088 7.18727 14.8015L7.18724 14.8015C7.15677 14.7969 7.1263 14.7923 7.09575 14.7883L7.07264 14.7852C6.94161 14.7674 6.81119 14.7498 6.68333 14.7249C6.61909 14.7124 6.55592 14.6969 6.49272 14.6814L6.49261 14.6814C6.46369 14.6743 6.43476 14.6672 6.40572 14.6604C6.28748 14.6318 6.1698 14.6033 6.05385 14.5696C5.97288 14.5454 5.8927 14.5177 5.81265 14.4901L5.81264 14.4901L5.76309 14.473C5.65742 14.4364 5.55174 14.3993 5.44892 14.3588C5.3461 14.3182 5.249 14.2736 5.15075 14.2285C5.0525 14.1834 4.96396 14.1411 4.87256 14.0943C4.76917 14.0406 4.66692 13.984 4.56639 13.9229C4.48642 13.876 4.40702 13.8281 4.32933 13.7784C4.22251 13.7104 4.11741 13.6395 4.01402 13.5647C3.94832 13.5179 3.88435 13.4693 3.82037 13.4202C3.71184 13.3362 3.60445 13.2488 3.50049 13.158C3.48411 13.1457 3.4687 13.1312 3.45315 13.1166C3.44485 13.1088 3.4365 13.101 3.42794 13.0934C3.45349 11.1501 4.70181 9.43416 6.54281 8.81177C7.46332 9.24971 8.5321 9.24971 9.45261 8.81177ZM10.5225 8.02286C12.0884 8.80112 13.2143 10.2507 13.5808 11.9606C14.4078 10.8047 14.8524 9.419 14.8524 7.99772C14.8539 5.03815 12.9551 2.4121 10.1443 1.48631C7.33347 0.56051 4.24595 1.54424 2.48864 3.92552C0.731331 6.30679 0.701469 9.54733 2.4146 11.9606C2.78117 10.2507 3.90702 8.80112 5.47291 8.02286C4.21856 6.65635 4.27887 4.53984 5.60899 3.24698C6.93911 1.95413 9.05631 1.95413 10.3864 3.24698C11.7166 4.53984 11.7769 6.65635 10.5225 8.02286Z"
                              />
                            </svg>
                            My Account
                          </div>
                        </router-link>
                      </li>
                      <li>
                        <router-link
                          @click.native="closeMenu()"
                          to="/profile/myNotification"
                          v-bind:class="[
                            $route.path == 'myNotification' ? 'active' : '',
                          ]"
                        >
                          <div>
                            <svg
                              width="16"
                              height="18"
                              viewBox="0 0 16 18"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                fill-rule="evenodd"
                                clip-rule="evenodd"
                                d="M16 11.6923C16 12.7112 15.1714 13.5385 14.1508 13.5385H1.8492C0.827975 13.5385 0 12.7124 0 11.6923C0 10.6736 0.827281 9.84615 1.8468 9.84615C1.8456 9.84615 1.84615 6.15361 1.84615 6.15361C1.84615 2.75418 4.6009 0 8 0C11.3991 0 14.1538 2.75484 14.1538 6.15361V9.84562C15.1712 9.84615 16 10.6733 16 11.6923ZM14.1532 11.0769C13.4732 11.0769 12.9231 10.5271 12.9231 9.84562V6.15361C12.9231 3.43456 10.7194 1.23077 8 1.23077C5.28058 1.23077 3.07692 3.43398 3.07692 6.15361V9.84562C3.07692 10.5252 2.5255 11.0769 1.8468 11.0769C1.50709 11.0769 1.23077 11.3533 1.23077 11.6923C1.23077 12.032 1.50709 12.3077 1.8492 12.3077H14.1508C14.4921 12.3077 14.7692 12.031 14.7692 11.6923C14.7692 11.3536 14.492 11.0769 14.1532 11.0769ZM6.46154 14.4615H5.23077C5.23077 15.9909 6.4706 17.2308 8 17.2308C9.5294 17.2308 10.7692 15.9909 10.7692 14.4615H9.53846C9.53846 15.3112 8.84967 16 8 16C7.15033 16 6.46154 15.3112 6.46154 14.4615Z"
                              />
                            </svg>
                            Notifications
                          </div>
                        </router-link>
                      </li>
                      <!-- <li>
                        <router-link to="/profile/myFavourites"
                          v-bind:class="[$route.path == 'myFavourites' ? 'active': '']">
                          <div>
                            <svg width="16" height="15" viewBox="0 0 16 15" fill="none"
                              xmlns="http://www.w3.org/2000/svg">
                              <path fill-rule="evenodd" clip-rule="evenodd"
                                d="M1.94334 10.5722C1.30123 14.1913 3.97746 16.0706 7.33766 14.3623L7.99994 14.0257L8.66221 14.3623C12.0232 16.071 14.6986 14.1904 14.0565 10.5722L13.9301 9.85932L14.466 9.3544C17.1849 6.79134 16.162 3.74972 12.4055 3.22188L11.6649 3.11791L11.3338 2.46926C9.65329 -0.823509 6.34581 -0.822667 4.66609 2.46926L4.33496 3.11791L3.59436 3.22188C-0.162899 3.74991 -1.18422 6.79199 1.53388 9.3544L2.06974 9.85932L1.94334 10.5722ZM9.24382 13.2918L7.99994 12.6593L6.75605 13.2918C4.31324 14.5334 2.70875 13.4082 3.1756 10.7767L3.41367 9.43706L2.40708 8.48836C0.431128 6.62602 1.04222 4.80277 3.77428 4.41884L5.16551 4.22332L5.78746 3.00449C7.00808 0.611884 8.99024 0.610294 10.2124 3.00449L10.8344 4.22332L12.2256 4.41884C14.9553 4.80249 15.5695 6.62471 13.5928 8.48836L12.5862 9.43706L12.8235 10.7767C13.2903 13.4064 11.6874 14.5342 9.24382 13.2918Z">
                              </path>
                            </svg>
                            My Favourites
                          </div>
                        </router-link>
                      </li>-->
                      <li>
                        <router-link
                          @click.native="closeMenu()"
                          to="/profile/myTransaction"
                          v-bind:class="[
                            $route.path == 'myTransaction' ? 'active' : '',
                          ]"
                        >
                          <div>
                            <svg
                              width="19"
                              height="16"
                              viewBox="0 0 19 16"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                fill-rule="evenodd"
                                clip-rule="evenodd"
                                d="M4.97927 0H15.9739C17.2369 0.00205197 18.2602 1.02539 18.2623 2.28838V3.54624C18.2623 3.80353 18.0537 4.01211 17.7964 4.01211H14.6154V13.7116C14.6134 14.9746 13.59 15.9979 12.327 16H2.28838C1.02539 15.9979 0.00205197 14.9746 0 13.7116V12.4538C0 12.1965 0.208579 11.9879 0.465875 11.9879H2.66853V2.31074C2.66956 1.03498 3.70351 0.0010276 4.97927 0ZM0.931749 13.7116C0.932776 14.4604 1.53956 15.0672 2.28838 15.0683H10.4859C10.1952 14.6757 10.0384 14.2001 10.0387 13.7116V12.9196H0.931749V13.7116ZM13.6837 2.28838V13.7116C13.6837 14.4614 13.0759 15.0692 12.3261 15.0692C11.5764 15.0692 10.9686 14.4614 10.9686 13.7116V12.4538C10.9686 12.1965 10.76 11.9879 10.5027 11.9879H3.59469V2.31074C3.59572 1.54957 4.21251 0.932776 4.97368 0.931749H14.1346C13.8423 1.3237 13.6842 1.79944 13.6837 2.28838ZM14.6154 3.08036H17.3305V2.28838C17.3305 1.53862 16.7227 0.930818 15.973 0.930818C15.2232 0.930818 14.6154 1.53862 14.6154 2.28838V3.08036ZM8.03913 5.34265C8.1096 5.4442 8.13682 5.5696 8.1148 5.69122C8.09278 5.81285 8.02333 5.92074 7.92173 5.99115C7.30352 6.42047 6.76708 6.95691 6.33776 7.57512C6.25259 7.6986 6.11317 7.77351 5.9632 7.77638H5.9427C5.78329 7.76959 5.63845 7.6817 5.55882 7.54344C5.40162 7.26823 5.17391 7.03988 4.89914 6.8819C4.67821 6.75239 4.60325 6.46883 4.7313 6.24706C4.85934 6.02528 5.14239 5.94843 5.36501 6.07501C5.58536 6.20209 5.78673 6.35954 5.9632 6.54274C6.38066 6.04147 6.86395 5.59892 7.39995 5.22711C7.60916 5.08626 7.89247 5.13747 8.03913 5.34265ZM12.1481 6.92662C12.4054 6.92662 12.614 6.71805 12.614 6.46075C12.614 6.20345 12.4054 5.99488 12.1481 5.99488H9.52434C9.26705 5.99488 9.05847 6.20345 9.05847 6.46075C9.05847 6.71805 9.26705 6.92662 9.52434 6.92662H12.1481ZM4.7277 3.33007C4.78869 3.22253 4.88993 3.14365 5.00912 3.11079C5.12831 3.07794 5.25567 3.09381 5.36315 3.1549C5.58386 3.28078 5.78584 3.43697 5.9632 3.61891C6.38064 3.11763 6.86393 2.67508 7.39995 2.30328C7.61145 2.15663 7.90179 2.20919 8.04845 2.42068C8.19511 2.63218 8.14255 2.92252 7.93105 3.06918C7.30948 3.49525 6.76924 4.02918 6.3359 4.6457C6.25234 4.77077 6.11354 4.84781 5.9632 4.85255H5.9427C5.78329 4.84576 5.63845 4.75787 5.55882 4.61961C5.40218 4.3478 5.17655 4.12216 4.90473 3.96553C4.79687 3.90484 4.71759 3.80374 4.68438 3.68453C4.65117 3.56531 4.66675 3.43778 4.7277 3.33007ZM12.1481 3.99348C12.4054 3.99348 12.614 3.7849 12.614 3.5276C12.614 3.27031 12.4054 3.06173 12.1481 3.06173H9.52434C9.26705 3.06173 9.05847 3.27031 9.05847 3.5276C9.05847 3.7849 9.26705 3.99348 9.52434 3.99348H12.1481ZM8.03913 8.26648C8.18625 8.47748 8.13453 8.76777 7.9236 8.91498C7.30541 9.34433 6.76898 9.88077 6.33962 10.499C6.25407 10.623 6.11383 10.6979 5.9632 10.7002H5.9427C5.78329 10.6934 5.63845 10.6055 5.55882 10.4673C5.40211 10.1955 5.17649 9.96989 4.90473 9.81318C4.7594 9.73056 4.66948 9.57639 4.66912 9.40922C4.66875 9.24204 4.75799 9.08748 4.90295 9.00422C5.04792 8.92095 5.22638 8.92174 5.3706 9.00629C5.58849 9.13155 5.78792 9.28646 5.9632 9.46657C6.38012 8.96546 6.86277 8.52292 7.39809 8.15094C7.60766 8.00886 7.89235 8.06017 8.03913 8.26648ZM12.1481 9.85045C12.4054 9.85045 12.614 9.64188 12.614 9.38458V9.38272C12.613 9.12615 12.4047 8.9187 12.1481 8.9187H9.52434C9.26705 8.9187 9.05847 9.12728 9.05847 9.38458C9.05847 9.64188 9.26705 9.85045 9.52434 9.85045H12.1481Z"
                              />
                            </svg>
                            My Transactions
                          </div>
                        </router-link>
                      </li>
                    </ul>
                  </b-dropdown>
                </div>
                <!-- <router-link to="/profile" class="px-2 text-white">Accounts</router-link> -->
                <div
                  v-on:click="onLogout()"
                  class="px-2 text-white logout-text c-pointer"
                >
                  Logout
                </div>
              </div>
            </b-navbar-nav>
          </b-collapse>
        </b-navbar>
      </header>
    </section>
    <!-- SEARCH BAR SECTION -->
    <section class="search-section" :style="{ right: hideSearch }">
      <div class="ml-auto">
        <button class="close mb-3" v-on:click="openSearch(true)">
          <img src="@/assets/img/svg/icon-close.svg" class="img-fluid" />
        </button>
      </div>
      <div class="container">
        <div class="d-flex w-100">
          <div class="grp-drop w-100">
            <b-input-group class="px-2">
              <b-form-input
                v-debounce:500="searchData"
                v-model="searchValue"
                placeholder="Search for movie"
                class="px-1"
              />
              <b-dropdown
                v-if="countryData"
                class
                :text="selectedCityName"
                variant="default"
                slot="append"
              >
                <b-dropdown-item
                  v-on:click="onChangeCityName(city)"
                  v-for="(city, cityIndex) in countryData.City"
                  :key="cityIndex"
                  >{{ city.CityName }}</b-dropdown-item
                >
              </b-dropdown>
            </b-input-group>
            <ul class="searchListData" v-if="searchValue">
              <li
                v-on:click="openSearch(true)"
                v-for="(movie, movieListIndex) in movieListSearch"
                :key="movieListIndex"
              >
                <router-link
                  :to="{
                    name: 'createScreen',
                    params: {
                      movie_id: movie.movie_id,
                      content_lang_id: movie.content_lang_id,
                    },
                  }"
                  >{{ movie.movie_title }}</router-link
                >
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
    <section
      class="container-fluid menu-bottom-fix d-md-none"
      v-if="showBottom"
    >
      <BOTTOMBAR />
    </section>
    <!-- COUNTRY SELECTION MODAL -->
    <b-modal
      no-close-on-esc
      no-close-on-backdrop
      hide-header-close
      ref="countryModalRef"
      id="countryModal"
      hide-header
      hide-footer
    >
      <div class="modal-title">Choose your Country</div>
      <div class="p-3">
        <div class="row">
          <div
            class="text-center col"
            v-for="(country, index) in countries"
            :index="index"
            :key="index"
          >
            <!-- <img
              :src="country.CountryFlag"
              height="60px"
              @click="setCountry(country)"
              class="flag-class"
              width="100px"
            /> -->
            <h6 class="pt-3">{{ country.country_name }}</h6>
          </div>
        </div>
      </div>
    </b-modal>
    <!-- Login Modal -->
    <div class="welcome-b">
      <!-- Modal Component -->
      <b-modal
        v-if="modal.signIn.info"
        hide-header-close
        hide-footer
        ref="signInModal"
        id="login"
        title="Welcome Back!"
        modal-class="welcome-b"
      >
        <button
          type="button"
          @click="hideSignIn()"
          aria-label="Close"
          class="close"
        >
          ×
        </button>
        <div class="col-12 loginmodal">
          <!-- USER LOGIN -->
          <div class="mob-login-box">
            <b-form
              @submit.prevent="validateBeforeSubmit('signIn')"
              data-vv-scope="signIn"
            >
              <b-input
                v-validate="'required|email'"
                name="email"
                v-model="userDetails.email"
                class="mt-3 npm mr-sm-2 pc-input"
                id="email"
                placeholder="Enter Your Email Address"
                @input="resetError()"
              />
              <div
                v-show="errors.has('signIn.email')"
                class="py-1 text-danger font-weight-bold small"
              >
                {{ errors.first("signIn.email") }}
              </div>
              <b-input
                v-model="userDetails.password"
                v-validate="'required|min:6'"
                type="password"
                class="mt-3 mr-sm-2 pc-input"
                name="password"
                id="inlineFormpassword"
                placeholder="Enter Your Password"
                @input="resetError()"
              />
              <div
                v-show="errors.has('signIn.password')"
                class="py-1 text-danger font-weight-bold small"
              >
                {{ errors.first("signIn.password") }}
              </div>
              <!-- <b-form-radio class="grey-text pc-radio mt-2 mb-2 mt-md-4 mb-md-2" v-on:click="onCheck()" value="A"
                            v-model="userDetails.termsAndConditions" name="some-radios">I agree to all Terms &
                            Conditions
              </b-form-radio>-->
              <div class="text-danger small font-weight-bold text-center">
                {{ errorMessage.login }}
              </div>
              <div class="my-3">
                <input
                  type="submit"
                  class="btn btn-danger gogo-btn"
                  value="Login"
                />
              </div>
            </b-form>
            <router-link to @click.native="showForgotPassword()"
              >Forgot Password?</router-link
            >
          </div>
          <!-- <b-button class="mt-3 mt-md-5 ml-md-2 nm-btn px-3 px-md-5">Proceed</b-button>                        -->
          <!-- USER LOGIN END -->
          <!-- SOCIAL LOGIN START-->
          <!-- <div class="col-md-5 mt-4 mt-md-0 px-0 pl-md-0">
                      <div class="social-login pl-md-5">
                        <p class="text-center mb-3 text-md-left">Sign in through social:</p>
                        <fb-signin-button class="btn fb-btn text-white" :params="fbSignInParams" @success="onSignFBInSuccess"
                          @error="onSignFBInError">
                          <div class="fb-btn">
                            <img class="mb-1 mr-3" src="@/assets/img/svg/facebook.svg" width="8" height="auto"
                              alt="Facebook-icon">Sign in with Facebook
                          </div>
          </fb-signin-button>-->
          <!-- <g-signin-button :params="googleSignInParams" @success="onGoogleSignInSuccess"
                          @error="onGoogleSignInError" class="btn g-btn mt-3">
                          <img src="@/assets/img/svg/google.svg" class="mb-1 mr-3" height="auto" width="20px" alt="Google-icon">
                          Sign in with Google
                        </g-signin-button>
                      </div>
          </div>-->
          <!-- SOCIAL LOGIN END-->
        </div>
        <p class="grey-text text-center pt-4">
          Don’t have an account with us?
          <router-link to @click.native="showSignUp">Sign Up</router-link>
        </p>
      </b-modal>
    </div>
    <!-- Forgot password Email-->
    <div class="welcome-b">
      <!-- Modal Component -->
      <b-modal
        v-if="modal.forgotpassword.email"
        hide-header-close
        ref="forgotpasswordEmailModal"
        id="forgotpassword"
        title="Forgot Password?"
        modal-class="welcome-b"
      >
        <button
          type="button"
          @click="hideForgotPassword()"
          aria-label="Close"
          class="close"
        >
          ×
        </button>
        <div class="row mx-4 my-4">
          <div class="col-md-12 loginmodal">
            <div class="mob-login-box">
              <b-form
                @submit.prevent="validateBeforeSubmit('forgotPassword')"
                data-vv-scope="signIn"
              >
                <b-input
                  v-validate="'required|email'"
                  name="email"
                  v-model="userDetails.email"
                  class="mb-2 mt-1 mr-sm-2 pc-input"
                  id="inlineFormInputpassword1"
                  placeholder="Enter Your Email Address"
                />
                <div class="text-danger small font-weight-bold">
                  {{ errorMessage.forgotpassword }}
                </div>
                <div class="mt-3">
                  <input
                    type="submit"
                    class="btn btn-danger gogo-btn"
                    value="Send OTP"
                  />
                </div>
              </b-form>
            </div>
          </div>
        </div>
      </b-modal>
    </div>
    <!-- Forgot Password Email -->
    <!-- forgot password OTP -->
    <div class="welcome-b">
      <!-- Modal Component -->
      <b-modal
        ref="ForgotPasswordOTPModal"
        hide-header-close
        id="ForgotPasswordOTP"
        title="Enter OTP"
        modal-class="welcome-b"
      >
        <button
          type="button"
          @click="hideForgotPasswordOTPModal()"
          aria-label="Close"
          class="close"
        >
          ×
        </button>
        <div class="row mx-4 my-4">
          <div class="col-md-12 loginmodal">
            <div class="mob-login-box">
              <form
                @submit.prevent="validateBeforeSubmit('fortpasswordVerifyOtp')"
                data-vv-scope="fortpasswordVerifyOtp"
              >
                <div class="p-2">
                  <p class="otp-text text-center mb-0">
                    Please enter the 6 digit verification code you might have
                    just received via email / SMS.
                  </p>
                  <div class="my-4 otp-section">
                    <div class="form-row">
                      <div class="d-flex otp-mob mx-auto">
                        <div class="col px-2 px-md-1">
                          <input
                            type="number"
                            id="otp1"
                            btnNumber="1"
                            class="form-control text-center otp_height"
                            placeholder
                            maxlength="1"
                            pattern="([12345])\w{0}"
                            v-model="userDetails.OTP[0]"
                            @input="OTPonKeyUp(0, $event)"
                            ref="fotp1"
                          />
                        </div>
                        <div class="col px-2 px-md-1">
                          <input
                            type="number"
                            id="otp2"
                            class="form-control text-center otp_height"
                            placeholder
                            maxlength="1"
                            pattern="([12345])\w{0}"
                            v-model="userDetails.OTP[1]"
                            @input="OTPonKeyUp(1, $event)"
                            ref="fotp2"
                          />
                        </div>
                        <div class="col px-2 px-md-1">
                          <input
                            type="number"
                            id="otp2"
                            class="form-control text-center otp_height"
                            placeholder
                            maxlength="1"
                            pattern="([12345])\w{0}"
                            v-model="userDetails.OTP[2]"
                            ref="fotp3"
                            @input="OTPonKeyUp(2, $event)"
                          />
                        </div>
                        <div class="col px-2 px-md-1">
                          <input
                            type="number"
                            id="otp2"
                            class="form-control text-center otp_height"
                            placeholder
                            maxlength="1"
                            pattern="([12345])\w{0}"
                            ref="fotp4"
                            @input="OTPonKeyUp(3, $event)"
                            v-model="userDetails.OTP[3]"
                          />
                        </div>
                        <div class="col px-2 px-md-1">
                          <input
                            type="number"
                            id="otp2"
                            class="form-control text-center otp_height"
                            placeholder
                            maxlength="1"
                            pattern="([12345])\w{0}"
                            ref="fotp5"
                            @input="OTPonKeyUp(4, $event)"
                            v-model="userDetails.OTP[4]"
                          />
                        </div>
                        <div class="col px-2 px-md-1">
                          <input
                            type="number"
                            id="otp2"
                            class="form-control text-center otp_height"
                            placeholder
                            maxlength="1"
                            pattern="([12345])\w{0}"
                            ref="fotp6"
                            @input="OTPonKeyUp(5, $event)"
                            v-model="userDetails.OTP[5]"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <p class="grey-text text-center mb-4">
                    Haven't received it yet?
                    <router-link @click.native="sendResetOTP()" to="#"
                      >Resend code</router-link
                    >
                  </p>
                  <div>
                    <div class="text-danger small font-weight-bold">
                      {{ errorMessage.otp }}
                    </div>
                    <input
                      type="submit"
                      class="btn btn-danger gogo-btn"
                      value="Submit"
                    />
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </b-modal>
    </div>
    <!-- forgot password otp end -->
    <!-- RESET PASSWORD -->
    <div class="welcome-b">
      <!-- Modal Component -->
      <b-modal
        ref="resetPassword"
        hide-header-close
        id="resetPassword"
        title="Enter New Password"
        modal-class="welcome-b"
      >
        <button
          type="button"
          @click="hideresetPassword()"
          aria-label="Close"
          class="close"
        >
          ×
        </button>
        <div class="row mx-4 my-4">
          <div class="col-md-12 loginmodal">
            <div class="mob-login-box">
              <b-form
                @submit.prevent="validateBeforeSubmit('resetPasswordForm')"
                data-vv-scope="resetPasswordForm"
              >
                <b-input
                  v-validate="'required|min:6'"
                  type="password"
                  name="Password"
                  v-model="userDetails.password"
                  class="mb-2 mt-1 mr-sm-2 pc-input"
                  id="password1"
                  placeholder="Enter Your Password"
                />
                <div
                  v-show="errors.has('resetPasswordForm.Password')"
                  class="py-1 text-danger font-weight-bold small"
                >
                  {{ errors.first("resetPasswordForm.Password") }}
                </div>
                <b-input
                  v-validate="'required|min:6'"
                  type="password"
                  name="Confirm Password"
                  v-model="userDetails.ConfirmPassword"
                  class="mb-2 mt-1 mr-sm-2 pc-input"
                  id="password2"
                  placeholder="Enter Your Confirm Password"
                />
                <div
                  v-show="errors.has('resetPasswordForm.Confirm Password')"
                  class="py-1 text-danger font-weight-bold small"
                >
                  {{ errors.first("resetPasswordForm.Confirm Password") }}
                </div>
                <div class="text-danger small font-weight-bold">
                  {{ errorMessage.resetPassword }}
                </div>
                <div class="mt-3">
                  <input
                    type="submit"
                    class="btn btn-danger gogo-btn"
                    value="Submit"
                  />
                </div>
              </b-form>
            </div>
          </div>
        </div>
      </b-modal>
    </div>
    <!-- RESET PASSWORD ENDS -->

    <div class="verify-c">
      <b-modal
        ref="resetPasswordSuccessModal"
        id="resetPasswordSuccessModal"
        title="Success!"
        modal-class="verify-c"
      >
        <div class="p-5">
          <div class="text-center mb-3">
            <img
              width="47"
              height="auto"
              src="@/assets/img/svg/tick-mark.svg"
            />
          </div>
          <div class="text-center text-success mt-3 mt-md-0">
            Awesome! Your Password has been reset successfully.
          </div>
        </div>
      </b-modal>
    </div>
    <!-- RESET PASSWORD SUCCESS ENDS -->
    <!-- Welcome Back Modal Ends -->
    <!-- Hello Stranger Modal -->
    <div class="hello-s">
      <!-- Modal Component -->
      <b-modal
        ref="signUp"
        hide-header-close
        hide-footer
        v-if="modal.signUp.info"
        id="signup"
        title="Hello Friend!"
        modal-class="hello-s"
      >
        <button
          type="button"
          @click="hideSignUp()"
          aria-label="Close"
          class="close"
        >
          ×
        </button>
        <b-form
          @submit.prevent="validateBeforeSubmit('signUp')"
          data-vv-scope="signUp"
        >
          <div class>
            <!-- SIGNUP LOGIN -->
            <div class="col-md-12 loginmodal">
              <div class="mob-login-box">
                <b-input
                  autocomplete="false"
                  name="email"
                  type="email"
                  class="mt-3 mr-sm-2 pc-input"
                  v-validate="'required|email'"
                  v-model="userDetails.email"
                  id="inlineFormInputNamemail"
                  placeholder="Enter Your Email Address"
                />
                <div
                  v-show="errors.has('signUp.email')"
                  class="py-1 text-danger font-weight-bold small"
                >
                  {{ errors.first("signUp.email") }}
                </div>
                <!-- <vue-tel-input v-model="phone" v-validate="'required|number'" name="phonenumber" class="mb-2 mt-1 mr-sm-2 pc-input form-control" placeholder="Enter Your Mobile Number" @onInput="onInput"></vue-tel-input> -->
                <div class="row align-items-center">
                  <div class="col-3 pr-0 pr-xl-2 country-code-drop">
                    <b-dropdown
                      v-if="CountryCodeList.length > 0"
                      class="pc-input form-control mt-3"
                      :text="userDetails.CountryCode.toString() || 'Code'"
                      variant="default"
                      slot="append"
                    >
                      <div class="px-2 pb-2">
                        <input
                          type="search"
                          placeholder="Search Code"
                          class="form-control form-control-sm"
                          v-on:keyup="onSearchCode($event.target.value)"
                          v-on:keydown="onSearchCode($event.target.value)"
                          v-on:search="onSearchCode($event.target.value)"
                          v-model="searchCode"
                        />
                      </div>
                      <b-dropdown-item
                        class
                        v-on:click="onChangeCountry(country)"
                        v-for="(country, countryIndex) in CountryCodeList"
                        :key="countryIndex"
                        >{{ country.country_mob_code }}&nbsp;
                        {{ country.country_name }}</b-dropdown-item
                      >
                    </b-dropdown>
                  </div>
                  <div class="col-9">
                    <b-input
                      name="Phone Number"
                      type="number"
                      :min="0"
                      class="mt-3 mr-sm-2 pc-input"
                      v-validate="'required|min:8|max:12'"
                      v-model="userDetails.phoneNumber"
                      pattern=""
                      @keyup="checkValidPhone"
                      placeholder="Enter Your Phone Number"
                    />
                  </div>
                  <div
                    v-show="errors.has('signUp.Phone Number')"
                    class="py-1 px-3 text-danger font-weight-bold small"
                  >
                    The Phone Number field
                    {{
                      userDetails.phoneNumber.toString().length < 9
                        ? "must be atleast 8 digits"
                        : userDetails.phoneNumber.toString().length > 12
                        ? "may not be  greater than  12 digits"
                        : ""
                    }}
                  </div>
                </div>
                <!-- <b-input class="mb-2 mt-3 mr-sm-2 pc-input" v-validate="'required'"
                            v-model="userDetails.phoneNumber" id="inlineFormInputName2"
                placeholder="Enter your Mobile Number" />-->
                <b-input
                  type="password"
                  name="password"
                  class="mt-3 mr-sm-2 pc-input"
                  v-validate="{
                    required: 'required',
                    regex:
                      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z0-9!@#$%^&*]{6,}$/,
                  }"
                  v-model="userDetails.password"
                  id="inlineFormInputNamepassword1"
                  placeholder="Enter Your Password"
                />
                <div
                  v-show="errors.has('signUp.password')"
                  class="py-1 text-danger font-weight-bold small"
                >
                  {{
                    !userDetails.password
                      ? passwordRequiredMessage
                      : passwordValidationMessage
                  }}
                  <!-- {{ errors.first("signUp.password") }} -->
                </div>
                <!-- <b-input type="text" class="mt-3 mr-sm-2 pc-input" v-validate="'required'"
                            v-model="userDetails.userName" id="inlineFormInputName2"
                placeholder="Enter Your Username" />-->
              </div>
              <b-form-checkbox
                class="grey-text pc-radio mt-2 mb-2 mt-md-2 mb-md-2"
                id="checkbox-1"
                v-model="userDetails.termsAndConditions"
                name="checkbox-1"
                value="accepted"
                unchecked-value="not_accepted"
              >
              I agree to receive text messages from GOGO Cinema
                <router-link
                  to="/termsCondition"
                  class="tnc-class"
                  target="_blank"
                  >Terms & Conditions</router-link
                >
              </b-form-checkbox>

                <b-form-checkbox
                class="grey-text pc-radio mt-2 mb-2 mt-md-2 mb-md-2"
                id="checkbox-1"
                v-model="userDetails.termsAndConditions"
                name="checkbox-1"
                value="accepted"
                unchecked-value="not_accepted"
              >
                I'd like to receive marketing emails
             
              </b-form-checkbox>
              <div class="py-2 text-danger font-weight-bold small">
                {{ errorMessage.signUp }}
              </div>
              <input
                type="submit"
                class="btn btn-danger gogo-btn"
                value="Create an Account"
              />
            </div>
            <!-- USER LOGIN END -->
            <!-- SOCIAL LOGIN START-->
            <!-- <div class="col-md-5 mt-4 mt-md-0 px-0 pl-md-0">
                        <div class="social-login pl-md-5">
                          {{socialLoginError.error}}
            <p class="text-center mb-3 text-md-left">Sign up through social:</p>-->
            <!-- <b-button class="fb-btn">
                          <img
                            class="mb-1 mr-3"
                            src="@/assets/img/svg/facebook.svg"
                            width="7"
                            height="auto"
                          >Sign in with Facebook
            </b-button>-->
            <!-- <fb-signin-button class="btn fb-btn text-white" :params="fbSignInParams" @success="onSignFBInSuccess"
                            @error="onSignFBInError">
                            <div class="fb-btn">
                              <img class="mb-1 mr-3" src="@/assets/img/svg/facebook.svg" width="8" height="auto"
                                alt="Facebook-icon">Sign in with Facebook
                            </div>
            </fb-signin-button>-->
            <!-- <b-button class="g-btn mt-3">
                          <img
                            class="mb-1 mr-3"
                            src="@/assets/img/svg/google.svg"
                            width="15"
                            height="auto"
                          >Sign in with Facebook
            </b-button>-->
            <!-- <g-signin-button :params="googleSignInParams" @success="onGoogleSignInSuccess"
                            @error="onGoogleSignInError" class="btn g-btn mt-3">
                            <img src="@/assets/img/svg/google.svg" class="mb-1 mr-3" height="auto" width="20px" alt="Google-icon">
                            Sign in with Google
            </g-signin-button>-->
            <!-- </div>
            </div>-->
            <!-- SOCIAL LOGIN END-->
            <div class="col-md-7 px-0 pr-md-5 mt-3 mt-md-0">
              <!-- <b-form-radio class="grey-text pc-radio mt-2 mb-2 mt-md-2 mb-md-2" value="A"
                          v-model="userDetails.termsAndConditions" name="some-radios">I agree to all Terms & Conditions
              </b-form-radio>-->
              <div></div>
            </div>
          </div>
        </b-form>
        <p class="grey-text text-center mb-0 py-4">
          Already a user?
          <router-link to @click.native="showSignIn">Sign In</router-link>
        </p>
      </b-modal>
    </div>
    <!-- Hello Stranger Modal End -->
    <!-- Verify Contact modal -->
    <div class="verify-c">
      <!-- <b-button v-b-modal.verifyContact>Verify Contact</b-button> -->
      <!-- Modal Component -->
      <b-modal
        ref="verifyContact"
        id="verifyContact"
        title="Verify Your Contact Detail"
        modal-class="verify-c"
      >
        <div class="p-5">
          <div class="text-center mb-3">
            <img
              width="47"
              height="auto"
              src="@/assets/img/svg/tick-mark.svg"
            />
          </div>
          <div class="text-center text-success mt-3 mt-md-0">
            Awesome! Your verification is complete and your account has been
            created!
          </div>
          <!-- <b-button
            href="/"
            class="gogo-btn btn btn-danger mt-3 d-flex justify-content-center align-items-center"
          >Start Browsing Movies</b-button>-->
        </div>
      </b-modal>
    </div>
    <!-- Verify Contact modal End -->
    <!-- Verify Your OTP Modal-->
    <div class="verify-otp">
      <!-- <b-button v-b-modal.otp>Verify otp</b-button> -->
      <!-- Modal Component -->
      <b-modal
        hide-header-close
        ref="OTPModal"
        id="otp"
        title="Verify Your Contact Detail"
        modal-class="verify-otp"
      >
        <button
          type="button"
          @click="hideSignUpOTP()"
          aria-label="Close"
          class="close"
        >
          ×
        </button>
        <form
          @submit.prevent="validateBeforeSubmit('verifyOtp')"
          data-vv-scope="verifyOtp"
        >
          <div class="p-5">
            <p class="otp-text text-center mb-0">
              Almost there! Please enter the 6 digit verification code you might
              have just received via email / SMS.
            </p>
            {{ errorMessage.otp }}
            <div class="my-4 otp-section">
              <div class="form-row">
                <div class="d-flex otp-mob mx-auto">
                  <div class="col px-2 px-md-1">
                    <input
                      type="number"
                      id="otp1"
                      btnNumber="1"
                      class="form-control text-center otp_height"
                      placeholder
                      maxlength="1"
                      pattern="([12345])\w{0}"
                      v-model="userDetails.OTP[0]"
                      @input="OTPonKeyUp1(0, $event)"
                      ref="sotp0"
                    />
                  </div>
                  <div class="col px-2 px-md-1">
                    <input
                      type="number"
                      id="otp2"
                      class="form-control text-center otp_height"
                      placeholder
                      maxlength="1"
                      pattern="([12345])\w{0}"
                      v-model="userDetails.OTP[1]"
                      @input="OTPonKeyUp1(1, $event)"
                      ref="sotp1"
                    />
                  </div>
                  <div class="col px-2 px-md-1">
                    <input
                      type="number"
                      id="otp2"
                      class="form-control text-center otp_height"
                      placeholder
                      maxlength="1"
                      pattern="([12345])\w{0}"
                      v-model="userDetails.OTP[2]"
                      ref="sotp2"
                      @input="OTPonKeyUp1(2, $event)"
                    />
                  </div>
                  <div class="col px-2 px-md-1">
                    <input
                      type="number"
                      id="otp2"
                      class="form-control text-center otp_height"
                      placeholder
                      maxlength="1"
                      pattern="([12345])\w{0}"
                      ref="sotp3"
                      @input="OTPonKeyUp1(3, $event)"
                      v-model="userDetails.OTP[3]"
                    />
                  </div>
                </div>
              </div>
            </div>
            <p class="grey-text text-center mb-4">
              Haven't received it yet?
              <router-link @click.native="validateBeforeSubmit('signUp')" to="#"
                >Resend code</router-link
              >
            </p>
            <div class="text-danger my-2 text-center">
              {{ errorMessage.signUp }}
            </div>
            <div>
              <input
                type="submit"
                class="gogo-btn btn btn-danger"
                value="Confirm your details"
              />
            </div>
          </div>
        </form>
      </b-modal>
      <b-modal
        no-close-on-esc
        no-close-on-backdrop
        hide-header-close
        hide-footer
        ref="registerMsg"
        class="text-center"
        id="registerMsg"
        title="Register SuccessFully !"
      >
        <div class="p-5">
          <div class="text-center mt-3 mt-md-0">Thanks For Joining Us.</div>
          <div class="d-flex w-100 mx-auto">
            <b-button
              v-on:click="validateBeforeSubmit('signIn')"
              class="
                w-50
                mr-2
                gogo-btn
                btn btn-danger
                mt-3
                d-flex-inline
                justify-content-center
                align-items-center
              "
              >Login</b-button
            >
            <b-button
              v-on:click="hideModal()"
              class="
                w-50
                ml-2
                gogo-btn
                btn btn-danger
                mt-3
                d-flex-inline
                justify-content-center
                align-items-center
              "
              >Cancel</b-button
            >
          </div>
        </div>
      </b-modal>
    </div>
  </div>
</template>
<script>
import { makeRequest } from "@/helper/internet.js";
import { TokenService, CountryService } from "@/services/storage.service";
import EventBus from "@/eventBus.js";
import CookieLaw from "vue-cookie-law";
import BOTTOMBAR from "@/components/partials/BottomBar.vue";
import { PROJECT_TITLE } from "@/helper/constants";
import MainServices from "@/services/mainService.js";
import AuthServices from "@/services/AuthServices.js";
import debounce from "debounce";

export default {
  data() {
    return {
      Regions: [],
      selectedRegion: "",
      selectedRegionId: null,
      DATEYEAR: "",
      phone: "",
      backdrop: false,
      rightOpen: "-100vw",
      hideSearch: "-100vw",
      fbSignInParams: {
        scope: "email",
        return_scopes: false,
      },
      googleSignInParams: {
        client_id:
          "911938447926-kls328d23otm80v12n1jq13h8ajeh57f.apps.googleusercontent.com",
      },
      // User Details
      userDetails: {
        password: "",
        email: "",
        CountryCode: "1",
        phoneNumber: "",
        OTP: ["", "", "", "", "", ""],
        userName: "",
        termsAndConditions: true,
        ConfirmPassword: "",
        country_id: 38,
        country_mob_code: "1",
      },
      socialLoginError: {
        error: "",
      },
      countries: [],
      selectedCity: {
        CityName: "",
        CityID: "",
      },
      selectedCityName: "",
      countryData: {},
      errorMessage: {
        login: "",
        signUp: "",
        checkout: "",
        otp: "",
        forgotpassword: "",
        resetPassword: "",
      },
      showBottom: false,
      modal: {
        signUp: {
          info: true,
          OTP: false,
        },
        signIn: {
          info: true,
          OTP: false,
        },
        forgotpassword: {
          email: true,
          OTP: false,
          resetPassword: false,
        },
      },
      isUserLoggedIn: false,
      searchValue: "",
      movieListSearch: [],
      CountryCodeList: [],
      TITLE: PROJECT_TITLE,
      CountryText: "",
      imageCountry: "",
      checkPhoneNumber: "",
      TempCust: {},
      searchCode: "",
      countriesCopy: [],
      passwordRequiredMessage: "Password is Required.",
      passwordValidationMessage:
        "Password must contain minimum 6 characters, Contains at least one Lowercase letter, one Uppercase letter and one Number",
    };
  },
  computed: {
    usernameInfo() {
      if (localStorage.getItem("user")) {
        let user = JSON.parse(localStorage.getItem("user"));
        let username = user.first_name;
        return username;
      } else {
        return false;
      }
    },
  },
  beforeMount() {
    if (!localStorage.getItem("guest_user_id")) {
      localStorage.setItem(
        "guest_user_id",
        Math.floor(100000000 + Math.random() * 900000000)
      );
    }
    let city = window.localStorage.getItem("City");
    city = JSON.parse(city);
    if (city) {
      this.selectedCity = city;
      this.selectedCityName = this.selectedCity.CityName;
    }

    this.getAllRegionList();
  },
  mounted: function () {
    this.getAllGetCountryList();
    this.checkToken();
    this.getNowShowingData();
    this.getUserProfile();
    EventBus.$on("MakeUserLogin", () => {
      this.checkToken();
    });
    EventBus.$on("profileUpdate", () => {
      this.$forceUpdate();
    });
    EventBus.$on("onSingnUp", (userDetails) => {
      // this.$refs.signUp.show();
      this.userDetails = userDetails;
      this.SignUpUser();
    });
    EventBus.$on("OnGoogleSignIn", (googleUser) => {
      this.onGoogleSignInSuccess(googleUser);
    });
    EventBus.$on("OnFacebookSignIn", (response) => {
      this.onSignFBInSuccess(response);
    });
    EventBus.$on("SHOWSIGNIN", () => {
      this.checkSignIn();
    });
    EventBus.$on("CHECKROUTE", (val) => {
      this.showBottom = val;
    });
    this.checkRoute();
    // this.getAllCountry();
    this.checkPhoneNumber = this.userDetails.phoneNumber;
  },

  components: {
    CookieLaw,
    BOTTOMBAR,
  },
  methods: {
    resetError() {
      this.errorMessage.login = "";
    },
    hideModal() {
      this.$refs.registerMsg.hide();
    },
    checkValidPhone(e) {
      if (
        String(e.key) !== "Backspace" &&
        String(e.key).match(
          /^[a-zA-Z!@#\$%\^\&*\\"\'\;\:\[\]\{\}\(\)\`\/\~)\(+=._-]+$/g
        )
      ) {
        this.userDetails.phoneNumber = this.checkPhoneNumber;
      } else if (String(e.key) !== "Backspace") {
        this.checkPhoneNumber = this.userDetails.phoneNumber;
      }
    },
    checkRoute() {
      let array = [
        // {
        //   routeName: "offers-promotions",
        //   value: "2"
        // },
        {
          routeName: "myaccount",
          value: "4",
        },
        {
          routeName: "myTransaction",
          value: "3",
        },
        {
          routeName: "cinema-page",
          value: "5",
        },
        {
          routeName: "cinema-movie-list",
          value: "5",
        },
      ];
      let count = 0;
      let path = window.location.pathname;
      array.map((x) => {
        if (path == "/") {
          EventBus.$emit("BOTTOMTABCHANGE", "1");
          count++;
        } else if (path.includes(x.routeName)) {
          setTimeout(() => {
            EventBus.$emit("BOTTOMTABCHANGE", x.value);
          }, 200);
          count++;
        }
      });
      if (count > 0) {
        this.showBottom = true;
      } else {
        this.showBottom = false;
      }
    },
    getAllRegionList() {
      MainServices.GetAllRegions()
        .then((response) => {
          const { data } = response;
          if (data.status) {
            this.Regions = data.Records;
            let obj = {
              region_id: null,
              region_name: "All",
            };
            this.Regions.unshift(obj);
            this.selectedRegion = "All";
          } else {
            this.Regions = [];
          }
        })
        .catch((err) => {
          console.log("Error:", err);
        });
    },
    onSearchCode() {
      if (this.searchCode && this.searchCode.length > 0) {
        this.CountryCodeList = this.countriesCopy.filter((x) => {
          if (
            x.country_mob_code &&
            x.country_mob_code
              .toLowerCase()
              .includes(this.searchCode.toLowerCase())
          ) {
            return x;
          } else if (
            x.country_name &&
            x.country_name.toLowerCase().includes(this.searchCode.toLowerCase())
          ) {
            return x;
          }
        });
      } else {
        this.CountryCodeList = this.countriesCopy;
      }
    },
    showForgotPassword() {
      this.$refs["signInModal"].hide();
      this.$refs["forgotpasswordEmailModal"].show();
    },
    showSignUp() {
      this.$refs["signInModal"].hide();
      this.$refs["signUp"].show();
    },
    showSignIn() {
      this.$refs["signUp"].hide();
      this.$refs["signInModal"].show();
    },
    Redirect() {
      if (this.countryData == null) {
        window.location.pathname = "/";
      } else {
        this.$router.push({
          path: "/",
        });
      }
    },
    onClickCountrySelector: function () {
      this.openSideNav();

      this.$refs.countryModalRef.show();
    },
    closeMenu() {
      this.$refs.hovermenu.hide();
    },
    getUserProfile: function () {
      let token = TokenService.getToken();
      makeRequest("/Account/GetUserProfile", "POST", token, null)
        .then((result) => {
          if (!result.error && result.res.data) {
            this.isUserLoggedIn = true;
          } else {
            TokenService.removeToken();
          }
        })
        .catch((error) => {
          TokenService.removeToken();
          console.log("Error", error);
        });
    },
    getNowShowingData: function () {
      let payload = {
        Version: "1",
      };
      makeRequest("/GetShows/", "POST", null, payload)
        .then((response) => {
          const { error, res } = response;
          this.userDetails.CountryCode =
            res.data.Default && res.data.Default.CountryISOCode;
        })
        .catch((error) => {
          console.log("Error", error);
        });
    },
    getAllCountry: function (country) {
      let array = [
        "hiw",
        "coming-soon",
        "termsCondition",
        "privacyPolicy",
        "faqs",
        "cookiesprivacyPolicy",
        "aboutus",
      ];
      let self = this;
      this.countryData = CountryService.getCountry();
      let count = 0;
      let path = window.location.pathname;
      array.map((x) => {
        if (path.includes(x)) {
          count++;
        }
      });
      MainServices.GetCountries()
        .then((response) => {
          const { data } = response;
          if (data.status) {
            this.countries = data.data;
            this.countriesCopy = data.data;
          }
        })
        .catch((err) => {
          console.log("error:", err);
        });
    },
    getAllGetCountryList: function () {
      MainServices.GetCountries()
        .then((response) => {

          const { data } = response;
          if (data.data.length > 0) {
            this.CountryCodeList = data.data;
            this.countries = data.data;
            this.countriesCopy = data.data;
            let countryId = this.$store.getters.getGlobalOptions.filter((x) => {
              return x.go_key == "OPERATION_COUNTRY";
            });
            if (countryId.length > 0) {
              let findCountryObj = data.data.filter((z) => {
                return z.country_id == countryId[0].go_value;
              });
              console.log(findCountryObj, "findCountryObj");
            }
          }
        })
        .catch((err) => {
          console.log("error:", err);
        });
    },
    setCountry: function (country) {
      this.CountryText = country.country_code;
      CountryService.saveCountry(country);
      window.location = "/";
      this.countryData = country;
    },
    onChangeCityName(selectedData) {
      this.selectedCity = selectedData;
      this.selectedCityName = this.selectedCity.CityName;
      window.localStorage.setItem("City", JSON.stringify(selectedData));
    },
    onChangeRegion(region) {
      this.selectedRegion = region.region_name;
      this.selectedRegionId = region.region_id;
      this.searchValue = "";
      this.movieListSearch = [];
    },
    onChangeCountry: function (country) {
      this.userDetails.CountryCode = country.country_mob_code;
      this.userDetails.country_mob_code = country.country_mob_code;
      this.userDetails.country_id = country.country_id;
    },

    onInput({ number, isValid, country }) {
      this.userDetails.phoneNumber = number;
      this.userDetails.CountryCode = country.dialCode;
    },
    onCheck: function () {
      this.userDetails.termsAndConditions =
        !this.userDetails.termsAndConditions;
    },
    openSideNav: function () {
      this.rightOpen = this.rightOpen == "0vw" ? "-100vw" : "0vw";
      if (this.rightOpen == "0vw") {
        document.getElementsByTagName("body")[0].style.overflow = "hidden";
        this.backdrop = true;
      } else {
        document.getElementsByTagName("body")[0].style.overflow = "auto";
        this.backdrop = false;
      }
    },
    checkToken: function () {
      let checkUserLoggedIn = localStorage.getItem("user");
      if (checkUserLoggedIn) {
        this.isUserLoggedIn = true;
      }
    },
    OTPonKeyUp: function (item, e) {
      this.userDetails.OTP[item] = e.data;
      if (e.data != "" && e.data != null && item < 5) {
        let value = "fotp" + (item + 2);
        this.$refs[value].focus();
      }
      let array = this.userDetails.OTP.filter((x) => {
        return x != "" && x != null;
      });

      if (array.length == 6) {
        this.verifyForgotPasswordOtp();
      }
    },
    OTPonKeyUp1: function (item, e) {
      this.userDetails.OTP[item] = e.data;
      if (e.data != "" && e.data != null && item < 3) {
        let value = "sotp" + (item + 1);
        this.$refs[value].focus();
      }
      let array = this.userDetails.OTP.filter((x) => {
        return x != "" && x != null;
      });

      if (array.length == 4) {
        this.verifyOtp();
      }
    },
    hideSignIn: function () {
      this.userDetails.OTP = ["", "", "", "", "", ""];
      this.userDetails.email = "";
      this.userDetails.password = "";
      this.$refs.signInModal.hide();
      this.resetError();
    },
    hideSignUp: function () {
      this.userDetails.email = "";
      this.userDetails.password = "";
      this.userDetails.phoneNumber = "";
      this.$refs.signUp.hide();
      this.resetError();
    },
    hideSignUpOTP: function () {
      this.userDetails.email = "";
      this.userDetails.password = "";
      this.userDetails.phoneNumber = "";
      this.OTP = ["", "", "", "", "", ""];
      this.$refs.OTPModal.hide();
      this.resetError();
    },
    hideForgotPassword: function () {
      this.userDetails.email = "";
      this.$refs.forgotpasswordEmailModal.hide();
      this.resetError();
    },
    hideForgotPasswordOTPModal: function () {
      this.userDetails.email = "";
      this.userDetails.OTP = ["", "", "", "", "", ""];
      this.$refs.ForgotPasswordOTPModal.hide();
      this.resetError();
    },
    hideresetPassword: function () {
      this.userDetails.email = "";
      this.userDetails.OTP = ["", "", "", "", "", ""];
      this.userDetails.password = "";
      this.userDetails.ConfirmPassword = "";
      this.$refs.resetPassword.hide();
      this.resetError();
    },
    onClickOTP(item, e) {
      let val = "sotp" + item;
      this.$refs[val].value = "";
    },
    searchData: function () {
      if (this.searchValue) {
        this.searchAPI();
      } else {
        this.movieListSearch = [];
      }
    },
    topNavHandler: function () {
      this.openSearch(false);
    },
    openSearch: function (status) {
      this.movieListSearch = [];
      if (status) {
        if (this.hideSearch == "0vw") {
          this.hideSearch = "-100vw";
        } else {
          this.hideSearch = "0vw";
        }
      } else if (!status) {
        this.hideSearch = "-100vw";
      }
    },
    searchAPI: function () {
      this.movieListSearch = [];
      MainServices.SearchMovie({
        search: this.searchValue,
        region_id: this.selectedRegionId,
      })
        .then((response) => {
          const { data } = response;
          if (data && data.Records.data.length > 0) {
            this.movieListSearch = data.Records.data;
          } else {
            this.movieListSearch = [];
          }
        })
        .catch((err) => {
          console.log("Error", err);
        });
    },
    onSignFBInSuccess(response) {
      console.log("Facebook Response >>>>>>>", response);
      makeRequest(`/Account/SocialLogin`, "POST", null, {
        FireBaseID: "",
        TokenFrom: "Facebook",
        stoken: response.authResponse.accessToken,
      })
        .then((result) => {
          console.log("Check Socal Facebook response From here ", result);
          //send token to loginuser
          this.loginUser(result.res.data.access_token);
          this.isUserLoggedIn = true;
          this.modal.signIn.info = false;
          this.$refs.signInModal.hide();
          this.$refs.signUp.hide();
          EventBus.$emit("onProfileSuccess");
          //result has
        })
        .catch((error) => {
          console.log("Face book Login Error", error);
        });
      // Testing;
      FB.api("/me", (data) => {
        console.log("Facebook Data ", data);
      });
    },

    onSignFBInError(error) {
      this.socialLoginError.error = "Whoops, !Something went wrong";
      setTimeout(() => {
        this.socialLoginError.error = "";
      }, 5000);
    },

    //google
    onGoogleSignInSuccess(googleUser) {
      const profile = googleUser.getBasicProfile();
      makeRequest(`/Account/SocialLogin`, "POST", null, {
        FireBaseID: "",
        TokenFrom: "Google",
        stoken: googleUser.Zi.id_token,
      })
        .then((result) => {
          this.modal.signIn.info = false;
          TokenService.saveToken(result.res.data.access_token);
          this.isUserLoggedIn = true;
          EventBus.$emit("onProfileSuccess");
          // window.location = "/";
        })
        .catch((error) => {
          console.log("Google Login Error", error);
        });
    },
    onGoogleSignInError(error) {
      // `error` contains any error occurred.
      this.socialLoginError.error = "Whoops, !Something went wrong";
      setTimeout(() => {
        this.socialLoginError.error = "";
      }, 5000);
    },
    validateBeforeSubmit(scope) {
      if (scope == "signIn") {
        this.$validator.validateAll(scope).then((result) => {
          if (result) {
            let payload = {
              email: this.userDetails.email,
              password: this.userDetails.password,
            };
            AuthServices.Login(payload)
              .then((response) => {
                const { data } = response;
                if (data.status && data.Records && data.Records.length > 0) {
                  this.isUserLoggedIn = true;
                  window.localStorage.setItem(
                    "user",
                    JSON.stringify(data.Records[0])
                  );
                  this.modal.signIn.info = false;
                  this.$refs.registerMsg.hide();
                } else {
                  this.errorMessage.login = data.message;
                }
              })
              .catch((err) => {
                console.log("error:", err);
                this.errorMessage.login = data.message;
              });
          }
        });
      }

      if (scope == "signUp") {
        this.errorMessage.signUp = "";
        this.userDetails.ConfirmPassword = this.userDetails.password;
        console.log(this.$validator.validateAll(scope));
        this.$validator
          .validateAll(scope)
          .then((result) => {
            if (
              this.userDetails.termsAndConditions &&
              this.userDetails.email &&
              this.userDetails.password &&
              this.userDetails.CountryCode &&
              this.userDetails.phoneNumber
            ) {
              this.SignUpUser();
              return;
            } else {
              this.errorMessage.signUp = "Please fill in all the details";
            }
          })
          .catch((err) => {
            console.log("result err", err);
          });
      }
      if (scope == "forgotPassword") {
        this.$validator.validateAll(scope).then((result) => {
          if (result) {
            this.sendResetOTP();
          }
          return;
        });
      }
      if (scope == "resetPasswordForm") {
        this.errorMessage.resetPassword = "";
        this.$validator.validateAll(scope).then((result) => {
          if (result) {
            if (this.userDetails.password == this.userDetails.ConfirmPassword) {
              let payload = {
                cust_email: this.TempCust.cust_email,
                cust_id: this.TempCust.cust_id,
                first_name: this.TempCust.first_name,
                otp: this.userDetails.OTP.toString().replace(/,/g, ""),
                password: this.userDetails.password,
              };
              AuthServices.ResetPassword(payload)
                .then((response) => {
                  const { data } = response;
                  if (data.status) {
                    this.$refs.ForgotPasswordOTPModal.hide();
                    this.$refs.resetPassword.hide();
                    this.$refs.resetPasswordSuccessModal.show();
                  } else {
                    this.errorMessage.resetPassword = data.message;
                  }
                })
                .catch((err) => {
                  console.log("error: ", err);
                  this.errorMessage.resetPassword = "Something went wrong";
                });
            } else {
              this.errorMessage.resetPassword =
                "Password do not match with confirm Password";
              return;
            }
            return;
          }
        });
      }
      if (scope == "fortpasswordVerifyOtp") {
        this.verifyForgotPasswordOtp();
      }
      if (scope == "verifyOtp") {
        this.verifyOtp();
      }
      if (scope == "signUpVerifyOTP") {
        this.verifyUser();
      }
    },
    SignUpUser() {
      this.showLoading();
      let payload = {
        email: this.userDetails.email,
        phone_no: this.userDetails.phoneNumber,
        password: this.userDetails.password,
        country_id: this.userDetails.country_id,
        first_name: this.userDetails.userName,
      };
      AuthServices.Register(payload)
        .then((response) => {
          const { data } = response;
          console.log("data response", data, response);
          if (data.status) {
            console.log("data", data);
            this.$refs.signUp.hide();
            this.$refs.registerMsg.show();
            // this.$refs.OTPModal.show();
            this.errorMessage.signUp = data.message;
            EventBus.$emit("onSignUpError", this.errorMessage.signUp);
            EventBus.$emit("onSignUpSuccess");
          } else {
            this.errorMessage.signUp = data.message;
            EventBus.$emit("onSignUpError", data.message);
          }
        })
        .catch((err) => {
          EventBus.$emit("onSignUpError", err);
          console.log("error:", err);
        })
        .finally(() => {
          this.hideLoading();
        });
    },
    resetError() {
      Object.keys(this.errorMessage).map((x) => {
        this.errorMessage[x] = "";
      });
    },
    loginUser: function (token) {
      TokenService.saveToken(token);
      this.isUserLoggedIn = true;
    },
    sendResetOTP: function () {
      this.showLoading();
      let payload = {
        email: this.userDetails.email,
      };
      AuthServices.ForgotPassword(payload)
        .then((response) => {
          const { data } = response;
          if (data.status) {
            this.TempCust = data.Records[0];
            this.$refs.forgotpasswordEmailModal.hide();
            this.$refs.ForgotPasswordOTPModal.show();
            this.modal.forgotpassword.OTP = true;
            this.errorMessage.otp = "";
          } else {
            this.errorMessage.forgotpassword = data.message;
          }
        })
        .catch((err) => {
          console.log("error:", err);
          this.errorMessage.forgotpassword = "Something went wrong";
        })
        .finally(() => {
          this.hideLoading();
        });
      // makeRequest("/Account/ResetPassword/", "POST", null, payload)
      //   .then(response => {
      //     const { error, res } = response;
      //     this.hideLoading();
      //     if (!error && res.data.Status) {
      //       this.$refs.forgotpasswordEmailModal.hide();
      //       this.$refs.ForgotPasswordOTPModal.show();
      //       this.modal.forgotpassword.OTP = true;
      //       this.errorMessage.otp = "";
      //       this.OTP = ["", "", "", ""];
      //     } else {
      //       this.hideLoading();
      //       this.errorMessage.forgotpassword = res.data.Message;
      //     }
      //   })
      //   .catch(error => {
      //     console.log("Error", error);
      //     this.errorMessage.forgotpassword = "Something went wrong";
      //   });
    },
    verifyForgotPasswordOtp: function () {
      this.errorMessage.otp = "";
      this.userDetails.password = "";
      this.showLoading();
      let payload = {
        cust_id: this.TempCust.cust_id,
        otp: this.userDetails.OTP.toString().replace(/,/g, ""),
      };
      AuthServices.VerifyOTP(payload)
        .then((response) => {
          const { data } = response;
          if (data.status) {
            this.$refs.ForgotPasswordOTPModal.hide();
            this.$refs.resetPassword.show();
          } else {
            this.errorMessage.otp = data.message;
          }
        })
        .catch((err) => {
          console.log("error:", err);
          this.errorMessage.otp = "Something Went Wrong";
        })
        .finally(() => {
          this.hideLoading();
        });
      // makeRequest("/Account/VerifyOTP/", "POST", null, payload)
      //   .then(response => {
      //     this.hideLoading();
      //     const { error, res } = response;
      //     if (!error && res.data.Status) {
      //       this.$refs.ForgotPasswordOTPModal.hide();
      //       this.$refs.resetPassword.show();
      //     } else {
      //       this.hideLoading();
      //       this.errorMessage.otp = res.data.Message;
      //     }
      //   })
      //   .catch(error => {
      //     console.log("Error", error);
      //     this.errorMessage.otp = error;
      //     //   resolve(null);
      //   });
    },
    verifyOtp: function () {
      this.errorMessage.otp = "";
      this.showLoading();
      let payload = {
        Email: this.userDetails.email,
        MobileNo: this.userDetails.phoneNumber,
        Password: this.userDetails.password,
        UserName: this.userDetails.userName,
        OTP: this.userDetails.OTP.toString().replace(/,/g, ""),
        FireBaseID:
          "e-SmvRUQAnM:APA91bF_Am5XZRsi-hsRwPMqk9CrJhDG1Jt-JCaXs2x0sAhEX7OM1phK8BEJPIlRJK2zogz-G01_DjIrGrGMlXLntRQjkpvHrxUlYl9Tcom-jinT6OSFPWiys9qNT21VZfmVEhbjW6Vm",
      };

      makeRequest("/Account/Verifyme", "POST", null, payload)
        .then((response) => {
          this.hideLoading();
          const { error, res } = response;
          if (!error && res.data.Status) {
            // Switch to OTP section
            this.$refs.OTPModal.hide();
            this.$refs.verifyContact.show();
            setTimeout(() => {
              this.$refs.verifyContact.hide();
            }, 3000);
            this.loginUser(res.data.access_token);
            EventBus.$emit("onProfileSuccess");
          } else {
            this.errorMessage.otp = res.data.Message;
          }
        })
        .catch((error) => {
          console.log("Error", error);
          //   resolve(null);
        });
    },
    onLogout() {
      window.localStorage.removeItem("access_token");
      window.localStorage.removeItem("user");
      window.location.reload();
      window.location.pathname = "/";
      this.isUserLoggedIn = false;
    },
    checkSignIn() {
      if (this.isUserLoggedIn === false) {
        this.$refs.signInModal.show();
      }
    },
  },
};
</script>

<style scoped>
header nav {
  height: 90px;
}

.flag-class {
  border-style: solid;
  border-width: 1px;
  cursor: pointer;
}

.grp-drop {
  background: #fff;
}

.bg-color {
  background: #e70d00;
}

.Cookie {
  position: initial;

  text-align: center;
}

.Cookie__button {
  display: none !important;
}

.width-100 {
  width: 100%;
}

.w-90 {
  width: 90% !important;
}

.backdrop {
  height: 100vh;
  width: 100%;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  position: fixed;
  z-index: 9999;
  background-color: rgba(0, 0, 0, 0.75);
}
.otp_height {
  height: 56px;
}

.navbar-dark .navbar-toggler-icon {
  background-image: url("data:image/svg+xml;utf8,<svg viewBox='0 0 30 30' xmlns='http://www.w3.org/2000/svg'><path stroke='rgba(255, 255, 255, 1)' stroke-width='2' stroke-linecap='round' stroke-miterlimit='10' d='M4 7h22M4 15h22M4 23h22'/></svg>");
}
</style>
<style>
.countrySelectionDropdown .dropdown-menu {
  max-height: 400px !important;
  overflow: scroll !important;
}
</style>



// WEBPACK FOOTER //
// src/components/partials/header.vue